// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-04T00:23:01.900Z
// Property: Brighton Woods (ID: 6767906449167177)
// Collections: 14 amenities, 4 floorplans (live), 17 photos, 74 POIs, 5 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449167177",
  "property_external_id": "1101855",
  "property_zillow_url": "https://www.zillow.com/apartments/anchorage-ak/brighton-woods/5XydMM/",
  "property_apartments_url": "https://www.apartments.com/brighton-woods-apartment-homes-anchorage-ak/r35kzh1/",
  "property_google_business_url": "https://www.google.com/maps/place/Brighton+Woods/data=!4m2!3m1!1s0x0:0xbeaa202af50619b?sa=X&ved=2ahUKEwjKt-Gp6oOTAxVMJkQIHZqTJl4Q_BJ6BAgOEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "47678981036",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "brighton-woods",
  "property_name": "Brighton Woods",
  "property_website_url": "https://www.brightonwoodsapartments.com",
  "property_domain": "https://www.brightonwoodsapartments.com",
  "property_address": "1204 Norman St",
  "property_full_address": "1204 Norman St, Anchorage, AK 99504",
  "property_address_1": "1204 Norman St",
  "property_address_2": null,
  "property_address_city": "Anchorage",
  "property_address_state": "AK",
  "property_address_zip_full": "99504",
  "property_address_zip": "99504",
  "property_address_country": "US",
  "property_address_county": "Anchorage Municipality",
  "property_neighborhood_address": "Northeast Anchorage",
  "property_address_latitude": "61.2107263",
  "property_address_longitude": "-149.7712546",
  "property_email": "brightonwoods@weidner.com",
  "property_phone": "(907) 308-5055",
  "property_call_tracking_phone": "907-308-5055",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Brighton Woods in Anchorage, AK, your perfect home awaits! Choose from spacious one or two-bedroom floor plans, each featuring a cozy fireplace in select units, large walk-in closets, and a private patio or balcony. Enjoy 24-hour access, on-site management, and inviting amenities like a playground and courtyard to enrich your lifestyle. ",
  "property_long_description": "Welcome to Brighton Woods, your serene retreat in the heart of Anchorage, AK! Our charming apartment community offers a variety of thoughtfully designed floor plans, including one and two-bedroom options, perfect for anyone looking to embrace a vibrant lifestyle. \n\nAt Brighton Woods, we prioritize your comfort and convenience. Enjoy 24-hour access to the property, and rest assured knowing that a dedicated property manager and maintenance team are always on site to address your needs. Our community features laundry facilities, ample storage, and the comfort of online payments and service requests, making your life easier.\n\nStep outside to enjoy our beautifully maintained courtyard, perfect for relaxation or social gatherings, featuring a grill and a delightful playground for children. Select homes also include cozy fireplaces, patios, and balconies that invite you to unwind in style. Say goodbye to clutter with our spacious closets, including walk-in options, tailored for your lifestyle.\n\nAs a smoke-free community, we prioritize your health and well-being while providing high-speed internet for all your connectivity needs. Our apartments also come equipped with modern kitchens, dishwashers, and dining areas designed for your convenience.\n\nDiscover the perfect blend of comfort, community, and convenience at Brighton Woods. Don’t wait—find your new home today! Browse our availability or schedule a tour to visit our welcoming community. Experience Anchorage living at its finest!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021c-4c8a-753d-92bd-b636fbf9d470.webp",
  "property_featured_image_media": {
    "alt_text": "Living and dining area in an apartment with a sectional sofa, coffee table, and dining set.",
    "public_id": "019d021c-4c8a-753d-92bd-b636fbf9d470",
    "storage_key": "property/6767906449167177/019d021c-4c8a-753d-92bd-b636fbf9d470.webp",
    "width": 1536,
    "height": 1024
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "131",
  "property_year_built": "1977",
  "property_year_renovated": null,
  "property_walk_score": "68",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.18320610687023",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $1,000",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "40",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://alaska-weidner.securecafe.com/onlineleasing/brighton-woods-0/floorplans.aspx",
  "property_resident_portal_url": "https://alaska-weidner.securecafenet.com/residentservices/brighton-woods-0/userlogin",
  "property_apply_now_url": "https://alaska-weidner.securecafe.com/onlineleasing/brighton-woods-0/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412a-cc12-7456-9bab-50770420b8af.webp",
  "property_primary_logo_media": {
    "alt_text": "Brighton Woods Apartment Homes logo",
    "public_id": "01a1412a-cc12-7456-9bab-50770420b8af",
    "storage_key": "property/6767906449167177/01a1412a-cc12-7456-9bab-50770420b8af.webp",
    "width": 87,
    "height": 75
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412b-1b90-77f9-8320-88d09f3260e8.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a1412b-1b90-77f9-8320-88d09f3260e8",
    "storage_key": "property/6767906449167177/01a1412b-1b90-77f9-8320-88d09f3260e8.webp",
    "width": 87,
    "height": 75
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412b-0ecf-769e-b1d3-ac272671ded2.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a1412b-0ecf-769e-b1d3-ac272671ded2",
    "storage_key": "property/6767906449167177/01a1412b-0ecf-769e-b1d3-ac272671ded2.webp",
    "width": 87,
    "height": 75
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#F0E8D2",
  "property_secondary_color": "#A8593A",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#2B3A4A",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 1.5",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1.5",
  "property_sqft_range": "680 - 950",
  "property_sqft_min": "650",
  "property_sqft_max": "950",
  "property_price_range": "1215 - 1850",
  "property_price_min": "1615",
  "property_price_max": "1850",
  "property_available_units": 5,
  "property_facebook_url": "https://www.facebook.com/BrightonWoodsApartments",
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJA3iyJZKWyFYRm2FQrwKi6gs",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Brighton Woods Apartments in Anchorage",
  "property_home_romance_title": "Welcome to Brighton Woods",
  "property_home_amenities_blurb": "Welcome to Brighton Woods in Anchorage, AK, where comfort meets convenience. Choose from spacious one- and two-bedroom floor plans, featuring select homes with cozy fireplaces and balconies. With 24-hour access, vibrant courtyards, and family-friendly playgrounds, experience a lifestyle designed for you—complete with online payments and on-site management. Enjoy your new home!",
  "property_home_floorplans_blurb": "Welcome to Brighton Woods, where cozy meets contemporary in the heart of Anchorage, AK. With a variety of thoughtfully designed floor plans, each apartment offers a unique touch of comfort and style. Browse our available homes, and let us help you find the perfect fit for your lifestyle today!",
  "property_home_gallery_blurb": "Welcome to Brighton Woods in Anchorage, AK, where comfort meets convenience. Choose from spacious one- and two-bedroom floor plans featuring modern amenities like in-home washers/dryers, large closets, and inviting patios or balconies. Enjoy our beautifully landscaped courtyard, playground, and 24-hour access, all in a smoke-free community. Picture yourself living here!",
  "property_home_neighborhood_blurb": "<p>Live close to everything Anchorage has to offer. Brighton Woods puts you near Russian Jack Plaza, great local eateries, and handy stops like Walmart and Carrs. With Glenn Highway and People Mover Route 30 close by, commuting and daily errands are a breeze. Parks, shopping, and lively streets surround you - giving you more time for what matters most.</p>",
  "property_home_reviews_blurb": "At Brighton Woods in Anchorage, AK, residents rave about their experience, with one saying, \"The sense of community here is unmatched.\" Our welcoming atmosphere and excellent amenities make Brighton Woods the perfect place to call home. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "<p>Discover the lifestyle of Brighton Woods Apartments in Anchorage, AK - where comfort meets convenience. Nestled among Anchorage's natural scenery, you're right at the crossroads of easy commutes and recreation. Enjoy quick access to the Glenn Highway and People Mover transit, or stroll over to Russian Jack Springs Park for fresh air and fun. Big-name employers like Alaska Pacific University, Providence Hospital, and JBER are nearby. Shopping at Walmart, Costco, and Kohl's makes errands easy, while local flavors like Palermo Pizza &amp; Philly's add tastes of home. For entertainment, Regal Tikahtnu IMAX is just around the corner. Here, neighborhood life means more connection, flavor, and possibilities every day.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Enjoy the best of in-home comfort and community convenience at Brighton Woods in Anchorage, AK. Inside your new apartment, relax in a space with thoughtful features like a dining room, dishwasher, and large closets. Select layouts enhance your experience with fireplaces, a private patio or balcony, and an in-home washer and dryer. Step outside to enjoy our community courtyard, stay active on winding walking paths, and do laundry in our on-site facilities. On-site management and online resident services make life here easy.</p>",
  "property_applynow_blurb": "Welcome to Brighton Woods, where comfort meets convenience in the heart of Anchorage, AK. Choose from spacious one and two-bedroom floor plans, each featuring modern amenities like in-home washers/dryers, large closets, and select homes with cozy fireplaces. Enjoy 24-hour access, a playground, and a serene courtyard. Find your new home and lease online today!",
  "property_contactus_blurb": "<p>Have questions about Brighton Woods or want more details about our apartments in Anchorage, AK? Reach out to our leasing professionals; our team is happy to guide you through your options, answer your questions, or help you schedule a tour.</p>",
  "property_faqs_blurb": "At Brighton Woods in Anchorage, AK, we offer thoughtfully designed one and two-bedroom floor plans to suit your lifestyle. Curious about our community? Navigate to our FAQs page for insightful answers to common questions, ensuring your transition to cozy, convenient living is smooth and seamless.",
  "property_floorplans_blurb": "<p>Choose from stunning one- or two-bedroom apartments for rent in Anchorage, AK. Each floor plan offers welcoming features like spacious closets, a dining room for gathering, and select homes with a fireplace or private patio/balcony. Ample storage and flexible space let you work from home, entertain, or relax in comfort.</p>",
  "property_gallery_blurb": "<p>Step into our photo gallery and see what life looks like at Brighton Woods in Anchorage, AK. Explore images of open kitchens, inviting living rooms, and tranquil green spaces. Imagine your favorite decor filling these bright rooms and days spent enjoying the inviting courtyard or relaxing at home. Scroll through and picture the Anchorage lifestyle - simple, comfortable, and designed for you.</p>",
  "property_interactivemap_blurb": "At Brighton Woods in Anchorage, AK, find your perfect one or two-bedroom haven equipped with modern comforts. From spacious walk-in closets to serene patios and a delightful courtyard, every detail invites relaxation. Use our interactive community map to uncover available homes and embrace the lifestyle you've always wanted!",
  "property_pets_blurb": "At Brighton Woods in Anchorage, AK, your furry friends can find their new home too! With no weight limits and a vibrant pet-friendly community, your cats and dogs will thrive here. Enjoy spacious living while ensuring your beloved companions are right by your side. Experience a life where pets truly belong!",
  "property_referafriend_blurb": "At Brighton Woods in Anchorage, AK, your perfect home awaits with spacious one and two-bedroom floor plans designed for comfort and style. Share the joy of community living—refer a friend today and enjoy the rewarding experience of fantastic neighbors in a pristine setting. Great friends make great neighbors!",
  "property_residentaccess_blurb": "Welcome to Brighton Woods in beautiful Anchorage, AK! Our thoughtfully designed one and two-bedroom apartments offer a perfect blend of comfort and style. Log into your resident portal to effortlessly pay rent, schedule maintenance, and enjoy a hassle-free living experience in our vibrant community!",
  "property_reviews_blurb": "At Brighton Woods in Anchorage, AK, our residents rave about the vibrant community atmosphere. One resident shares, \"Living here feels like home, with friendly neighbors and stunning views!\" Curious about the experiences that make us special? See what our residents have to say about living at our community!",
  "property_created_at": "1771536215853",
  "property_scheduletour_blurb": "<p>Ready to see Brighton Woods for yourself? Choose a live virtual tour or an in-person walkthrough at your own pace. Our Anchorage location offers both options, so you can preview your new one- or two-bedroom apartment, connect with our warm leasing team, and explore spaces like the courtyard or laundry room before you decide. Book a visit using our easy scheduler.</p>",
  "property_thankyou_blurb": "Thank you for reaching out to Brighton Woods in picturesque Anchorage, AK! With thoughtfully designed one and two-bedroom floor plans, your perfect home awaits. Our team will connect with you soon to help you embark on a journey to a new living experience nestled in nature's beauty.",
  "property_virtualtours_blurb": "<p>Experience Brighton Woods Apartments in Anchorage, AK without stepping outside your door. Our virtual tours guide you through spacious layouts, inviting atmospheres, and welcoming community spots. With just a few clicks, discover what it feels like to live in a place where comfort and convenience blend into your everyday. Use our virtual scheduler for a live video chat, or explore on your own time and imagine the Anchorage lifestyle you could enjoy.</p>",
  "property_copyright": "2026 All Rights Reserved. Brighton Woods",
  "property_seo_title_home": "Comfortable Apartments | Brighton Woods | Anchorage, AK",
  "property_seo_description_home": "Enjoy modern living at Brighton Woods in Anchorage, AK, pet-friendly, near Russian Jack Plaza, with easy access to Glenn Highway.",
  "property_seo_title_floorplans": "Floor Plans | Brighton Woods | Anchorage, AK",
  "property_seo_description_floorplans": "Find your next 1- or 2-bedroom apartment at Brighton Woods in Anchorage, AK - flexible layouts for any lifestyle.",
  "property_seo_title_amenities": "Amenities | Brighton Woods | Anchorage, AK",
  "property_seo_description_amenities": "Discover apartment and community amenities at Brighton Woods in Anchorage, AK - from large closets to courtyard spaces.",
  "property_seo_title_gallery": "Photo Gallery | Brighton Woods | Anchorage, AK",
  "property_seo_description_gallery": "Explore the Brighton Woods Apartments photo gallery in Anchorage, AK. Picture yourself in modern spaces and a vibrant community.",
  "property_seo_title_virtualtours": "Virtual Tour | Brighton Woods | Anchorage, AK",
  "property_seo_description_virtualtours": "Explore Brighton Woods virtually in Anchorage, AK. Take a 3D tour and picture your future home from anywhere.",
  "property_seo_title_interactivemap": "Interactive Map | Brighton Woods Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Brighton Woods, Anchorage! Explore spacious 1-2 bedroom apartments with great amenities using our interactive map!",
  "property_seo_title_neighborhood": "East Anchorage | Brighton Woods | Anchorage, AK",
  "property_seo_description_neighborhood": "Discover east Anchorage living near Russian Jack Plaza at Brighton Woods - parks, dining, and employers are all close by in Anchorage, AK.",
  "property_seo_title_contact": "Contact Brighton Woods Apartments | Anchorage, AK",
  "property_seo_description_contact": "Connect with the leasing team at Brighton Woods Apartments in Anchorage, AK. We're here to assist you.",
  "property_seo_title_faqs": "FAQs | Apartments in Anchorage, AK",
  "property_seo_description_faqs": "Discover Brighton Woods in Anchorage, AK! Our FAQs cover floor plans, amenities, and everything you need about our vibrant community.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Anchorage, AK",
  "property_seo_description_reviews": "Experience Brighton Woods in Anchorage, AK! Check out resident reviews, and learn about our spacious one and two-bedroom apartments with fantastic amenities.",
  "property_seo_title_applynow": "Apply Now | Apartments in Anchorage, AK",
  "property_seo_description_applynow": "Discover your haven at Brighton Woods, Anchorage, AK. Enjoy modern one or two-bedroom apartments. Apply online and embrace comfort!",
  "property_seo_title_residentaccess": "Resident Access | Brighton Woods",
  "property_seo_description_residentaccess": "Unlock convenience at Brighton Woods in Anchorage! Access your resident portal for easy rent payments, maintenance requests, and exclusive community updates.",
  "property_seo_title_referafriend": "Refer A Friend | Brighton Woods",
  "property_seo_description_referafriend": "Refer a friend to Brighton Woods in Anchorage, AK! Great friends make great neighbors—share the joy of life in our vibrant community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Brighton Woods | Anchorage, AK",
  "property_seo_description_scheduletour": "Book your in-person or virtual tour at Brighton Woods Apartments in Anchorage, AK. Discover flexible touring options.",
  "property_seo_title_privacy": "Privacy Policy | Brighton Woods",
  "property_seo_description_privacy": "Your peace of mind matters at Brighton Woods. Learn how we protect your information and ensure your privacy in Anchorage, AK. View our privacy policy today.",
  "property_seo_title_accessibility": "Website Accessibility | Brighton Woods",
  "property_seo_description_accessibility": "At Brighton Woods in Anchorage, AK, we prioritize digital inclusion and accessibility, ensuring everyone feels at home in our community.",
  "property_seo_title_sitemap": "Sitemap | Brighton Woods",
  "property_seo_description_sitemap": "Navigate Brighton Woods in Anchorage, AK, with our sitemap! Easily find your dream home amidst lush landscapes and inviting amenities. Your new life awaits!",
  "property_seo_title_thankyou": "Thank You | Brighton Woods",
  "property_seo_description_thankyou": "Thank you for contacting Brighton Woods in Anchorage, AK! Our team will connect with you soon to assist with your apartment search.",
  "property_seo_title_pets": "Pet Policy | Apartments in Anchorage, AK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793654764141",
  "amenities": [
    {
      "id": "ec_a8f869c20f6f9ef94a7b42e9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "yardi",
      "external_id": "87455964",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f4669c6d638b2a5857e88fe4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "yardi",
      "external_id": "87455965",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a08afd72ca3d27d0d641989a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "yardi",
      "external_id": "87455966",
      "title": "Laundry Room/Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_56f02985e73593072d54f549",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "yardi",
      "external_id": "87455967",
      "title": "On-site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5821fa38be1c56e4d56b6adc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "yardi",
      "external_id": "87455968",
      "title": "On-site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_85dd829d47ba102d3af19bbf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "yardi",
      "external_id": "87455986",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d444064f5fec77f8ec5d0657",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "yardi",
      "external_id": "87455987",
      "title": "Fireplace in Select Homes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_69251896b8699e959d399586",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "yardi",
      "external_id": "87455989",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f06eff9f2bda72fefb4d790e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "yardi",
      "external_id": "87455990",
      "title": "Patio/Balcony in Select Homes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0dd25a31126ff6e3d9a25a43",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "yardi",
      "external_id": "87455991",
      "title": "In-Home Washer/Dryer in Select Homes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021c-7ef0-75c5-851e-5cfe56f06fef.webp",
      "amenity_image_media": {
        "alt_text": "Stacked washing machine and dryer unit in a closet.",
        "public_id": "019d021c-7ef0-75c5-851e-5cfe56f06fef",
        "storage_key": "property/6767906449167177/019d021c-7ef0-75c5-851e-5cfe56f06fef.webp",
        "width": 3072,
        "height": 2048
      },
      "amenity_image_alt_text": "Brighton Woods Apartments - Washer Dryer",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ab165579373602be74cda1e9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "yardi",
      "external_id": "87455992",
      "title": "Dining Room",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f22ca140a6a0f6083bd7104e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "yardi",
      "external_id": "87455969",
      "title": "Online Payments & Service Requests",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_56364d02c6883c48aef9b530",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "yardi",
      "external_id": "87455970",
      "title": "Storage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_636b7900ec793e35ac3c883b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "yardi",
      "external_id": "124799793",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_cdccb3965a33392c793a00d2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021c-4c8a-753d-92bd-b636fbf9d470.webp",
      "image_media": {
        "alt_text": "Living and dining area in an apartment with a sectional sofa, coffee table, and dining set.",
        "public_id": "019d021c-4c8a-753d-92bd-b636fbf9d470",
        "storage_key": "property/6767906449167177/019d021c-4c8a-753d-92bd-b636fbf9d470.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring a comfortable sectional sofa, a modern coffee table, and a dining set perfect for meals and gatherings.",
      "link": "false",
      "alt_text": "A spacious Brighton Woods living and dining area with soft neutral décor, featuring a large light gray sectional sofa, two coordinating area rugs, and a wooden coffee table. A matching dining set for six sits nearby, accented by a potted plant and simple wall art, all illuminated by warm overhead lighting and a bright window view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Brighton-Woods_Favorites%20(1).jpg"
    },
    {
      "id": "ec_4f80d4faaa53906193c393f4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021c-4d56-7058-b5f6-6c94c8d7f79a.webp",
      "image_media": {
        "alt_text": "Kitchen and dining area with stairs.",
        "public_id": "019d021c-4d56-7058-b5f6-6c94c8d7f79a",
        "storage_key": "property/6767906449167177/019d021c-4d56-7058-b5f6-6c94c8d7f79a.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Open concept living space featuring a kitchen with wooden cabinets and a dining area with a table and chairs, adjacent to carpeted stairs.",
      "link": "false",
      "alt_text": "A bright Brighton Woods kitchen and dining area featuring warm wood cabinets, white appliances, and soft lighting. A light wood dining table with cushioned chairs sits beside a large window, while carpeted stairs lead upward from the open layout, creating a clean and inviting flow between spaces.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Brighton-Woods_Favorites%20(2).jpg"
    },
    {
      "id": "ec_d9177c3f5660afe83e88d8da",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021c-4ca7-7002-8cab-3f8d2f730806.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, plush bedding, and two abstract art pieces above the headboard.",
        "public_id": "019d021c-4ca7-7002-8cab-3f8d2f730806",
        "storage_key": "property/6767906449167177/019d021c-4ca7-7002-8cab-3f8d2f730806.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Relax in this serene bedroom, featuring a comfortable queen-size bed, soft linens, and tasteful decor. A large window offers views of the surrounding greenery.",
      "link": "false",
      "alt_text": "A serene Brighton Woods bedroom featuring a large window that frames green treetops and fills the room with daylight. A plush bed dressed in white linens and warm earth-tone pillows sits against a soft yellow wall, complemented by matching nightstands, soft carpet, and simple abstract artwork for a peaceful retreat.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Brighton-Woods_Favorites%20(3).jpg"
    },
    {
      "id": "ec_26b61369dcd65969fefdaf47",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021c-4c86-747b-82bc-3fac781671eb.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, dresser, and window.",
        "public_id": "019d021c-4c86-747b-82bc-3fac781671eb",
        "storage_key": "property/6767906449167177/019d021c-4c86-747b-82bc-3fac781671eb.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Comfortable bedroom featuring a queen-size bed with a green comforter, a wooden dresser, and a window with natural light.",
      "link": "false",
      "alt_text": "A charming Brighton Woods bedroom decorated in soft green tones with a neatly made bed featuring botanical-patterned bedding and layered pillows. A large window framed by matching curtains brings in natural light, while a light wood dresser with artwork and a tall floor lamp add warmth to the cozy space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Brighton-Woods_Favorites%20(4).jpg"
    },
    {
      "id": "ec_d5234ac9a0228e6a229fd8a5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021c-57cd-709c-a036-e4bb9c5ab1c6.webp",
      "image_media": {
        "alt_text": "Empty living room with a white door and window.",
        "public_id": "019d021c-57cd-709c-a036-e4bb9c5ab1c6",
        "storage_key": "property/6767906449167177/019d021c-57cd-709c-a036-e4bb9c5ab1c6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living room with neutral carpeting, a white entry door, and a large window offering a view of trees. Perfect for personalizing your new home.",
      "link": "false",
      "alt_text": "A spacious Brighton Woods living room with neutral beige carpeting and soft cream walls offering a blank canvas for any style. Large windows bring in natural light and frame views of evergreens outside, while ceiling lights and a white entry door complete the clean and open layout.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Brighton-Woods_Favorites%20(5).JPG"
    },
    {
      "id": "ec_043c4ac47d0dcd535c43c40f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021c-586e-749e-a2d9-484da8887444.webp",
      "image_media": {
        "alt_text": "Open concept living space with kitchen area, featuring carpeted floors, beige walls, and a white front door.",
        "public_id": "019d021c-586e-749e-a2d9-484da8887444",
        "storage_key": "property/6767906449167177/019d021c-586e-749e-a2d9-484da8887444.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious open-concept living and dining area with an adjacent kitchen. Enjoy ample natural light and comfortable carpeting throughout.",
      "link": "false",
      "alt_text": "A roomy Brighton Woods living area with soft beige carpeting and cream walls flowing into an open kitchen with warm wood cabinetry and a white refrigerator. Ceiling lights brighten the space, and a front entry door and nearby hallway offer access to bedrooms and storage, creating a practical and comfortable layout.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Brighton-Woods_Favorites%20(6).JPG"
    },
    {
      "id": "ec_f9d7e54cbc35cce410d55448",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021c-5942-7728-90e9-b9f6c17f37c9.webp",
      "image_media": {
        "alt_text": "Kitchen and living area with stairs.",
        "public_id": "019d021c-5942-7728-90e9-b9f6c17f37c9",
        "storage_key": "property/6767906449167177/019d021c-5942-7728-90e9-b9f6c17f37c9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A bright and spacious kitchen and living area featuring wooden cabinets, a white refrigerator, stove, and dishwasher. Stairs lead up to the next level, and a large window provides natural light.",
      "link": "false",
      "alt_text": "A bright Brighton Woods kitchen and dining space featuring warm wood cabinets, white appliances, and a neutral countertop arranged in an L-shape. Soft carpeting flows into the room from an adjacent open living area, with a cozy staircase leading upstairs and a large window bringing in natural light for an inviting everyday layout.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Brighton-Woods_Favorites%20(7).JPG"
    },
    {
      "id": "ec_16e35a0367184d5841185f25",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021c-5a56-722a-986e-74197dbb6462.webp",
      "image_media": {
        "alt_text": "Kitchen with brown cabinets, white countertops, a double sink, and a white stove.",
        "public_id": "019d021c-5a56-722a-986e-74197dbb6462",
        "storage_key": "property/6767906449167177/019d021c-5a56-722a-986e-74197dbb6462.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A bright and functional kitchen featuring ample cabinet space, a double sink, and a modern white stove. Perfect for everyday cooking and entertaining.",
      "link": "false",
      "alt_text": "A cozy Brighton Woods kitchen with warm brown cabinets, white countertops, and matching white appliances, including a dishwasher and electric stove. The counters wrap around in an L-shape, providing prep space beside the double stainless-steel sink, with soft neutral walls and flooring framing the cozy, functional layout.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Brighton-Woods_Favorites%20(8).JPG"
    },
    {
      "id": "ec_7201510c0bc535be97b6d5c6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021c-686d-755c-b02a-02cbd6dd4f20.webp",
      "image_media": {
        "alt_text": "Kitchen with wooden cabinets, white countertop, white stove, and double sink.",
        "public_id": "019d021c-686d-755c-b02a-02cbd6dd4f20",
        "storage_key": "property/6767906449167177/019d021c-686d-755c-b02a-02cbd6dd4f20.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A bright and functional kitchen featuring ample cabinet space, a white stove, and a double sink, perfect for preparing meals.",
      "link": "false",
      "alt_text": "A warm Brighton Woods kitchen featuring wood-grain cabinets, white countertops, and matching white appliances. The electric stove sits beneath a vent hood, while a double stainless-steel sink lines the L-shaped counter. Soft neutral walls and light flooring make the space bright and functional for daily cooking and cleanup.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Brighton-Woods_Favorites%20(9).JPG"
    },
    {
      "id": "ec_905b55ab811e15a546e03252",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021c-6894-7411-863b-17021be6e15d.webp",
      "image_media": {
        "alt_text": "Empty bedroom with a window overlooking trees and a doorway leading to another room.",
        "public_id": "019d021c-6894-7411-863b-17021be6e15d",
        "storage_key": "property/6767906449167177/019d021c-6894-7411-863b-17021be6e15d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom with neutral carpet and light yellow walls, featuring a large window and access to another room.",
      "link": "false",
      "alt_text": "A simple Brighton Woods bedroom showcasing soft beige walls and plush carpeted flooring, lit by a ceiling light and natural daylight from a wide window. The room features baseboard heating beneath the window and an open doorway that leads into the hallway, offering a blank canvas ready for personal furniture and decor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Brighton-Woods_Favorites%20(10).JPG"
    },
    {
      "id": "ec_4b46799e5f20615f915a9b30",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021c-6b28-710f-af90-8be770bb03a8.webp",
      "image_media": {
        "alt_text": "Bedroom with closet and laundry area",
        "public_id": "019d021c-6b28-710f-af90-8be770bb03a8",
        "storage_key": "property/6767906449167177/019d021c-6b28-710f-af90-8be770bb03a8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a large closet and a separate laundry area with washer and dryer. Cozy carpet and neutral walls create a welcoming atmosphere.",
      "link": "false",
      "alt_text": "A spacious Brighton Woods bedroom with soft beige walls and plush carpeted flooring, illuminated by a ceiling light. The room features an open walk-in closet to the left and a doorway leading to a laundry nook with a stacked washer and dryer. A second open door reveals built-in shelves, providing extra storage and flexibility for daily living.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Brighton-Woods_Favorites%20(11).JPG"
    },
    {
      "id": "ec_0e9f30e2cc111510073137e5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021c-6c63-73fe-aae9-791f8ab79c50.webp",
      "image_media": {
        "alt_text": "Interior view of a carpeted bedroom with a sliding glass door leading to a balcony overlooking trees.",
        "public_id": "019d021c-6c63-73fe-aae9-791f8ab79c50",
        "storage_key": "property/6767906449167177/019d021c-6c63-73fe-aae9-791f8ab79c50.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and well-lit bedroom featuring plush carpeting and a sliding glass door that opens to a private balcony with scenic views of the surrounding greenery.",
      "link": "false",
      "alt_text": "A bright Brighton Woods bedroom featuring soft carpeted flooring and a warm neutral wall color. The room includes a sliding glass door that opens to a private balcony with wooden railings, offering a scenic view of nearby trees and rooftops. A ceiling light provides illumination, creating a simple and inviting space ready for personalization.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Brighton-Woods_Favorites%20(12).JPG"
    },
    {
      "id": "ec_808b0ba2c7e90217fe1ebb1e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021c-7abe-749c-8efc-7b62d02159ba.webp",
      "image_media": {
        "alt_text": "Bathroom with a sink, toilet, and bathtub with shower.",
        "public_id": "019d021c-7abe-749c-8efc-7b62d02159ba",
        "storage_key": "property/6767906449167177/019d021c-7abe-749c-8efc-7b62d02159ba.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This is a bathroom with a sink, toilet, and a bathtub with a shower. It features a medicine cabinet above the sink and a towel rack on the wall.",
      "link": "false",
      "alt_text": "A tidy Brighton Woods bathroom featuring a white single-sink vanity with wood cabinetry, a wall-mounted mirrored medicine cabinet, and soft overhead lighting. A full bathtub and shower combination with built-in shelving sits beside a standard toilet, all set against light walls and patterned vinyl flooring, creating a clean and functional space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Brighton-Woods_Favorites%20(13).JPG"
    },
    {
      "id": "ec_83e13b88670b5fd1587e5468",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021c-7ada-704e-8d31-0bbb460b2fda.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and bathtub with shower",
        "public_id": "019d021c-7ada-704e-8d31-0bbb460b2fda",
        "storage_key": "property/6767906449167177/019d021c-7ada-704e-8d31-0bbb460b2fda.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a vanity with sink, a toilet, and a bathtub with a shower. This space offers essential amenities for daily comfort.",
      "link": "false",
      "alt_text": "A bright Brighton Woods bathroom featuring a full white bathtub and shower combo with built-in shelving, set beside a compact vanity with a stone-look countertop and wood cabinetry. Neutral walls, a mounted medicine cabinet, and a wall shelf above the toilet create a clean, practical layout with easy-to-use fixtures and simple flooring.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Brighton-Woods_Favorites%20(14).JPG"
    },
    {
      "id": "ec_ae22d273b4d57a67afd749fe",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021c-7ef0-75c5-851e-5cfe56f06fef.webp",
      "image_media": {
        "alt_text": "Stacked washing machine and dryer unit in a closet.",
        "public_id": "019d021c-7ef0-75c5-851e-5cfe56f06fef",
        "storage_key": "property/6767906449167177/019d021c-7ef0-75c5-851e-5cfe56f06fef.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Convenient in-unit stacked washer and dryer for easy laundry access.",
      "link": "false",
      "alt_text": "A compact Brighton Woods laundry nook featuring a stacked white washer and dryer beside an open door leading into a carpeted room.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Brighton-Woods_Favorites%20(15).JPG"
    },
    {
      "id": "ec_0be48426e92f838ce727f27b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a037a1-c356-770b-8e62-e018780e2bb5.webp",
      "image_media": {
        "alt_text": "Brighton Woods Apartment Homes signage and building exterior.",
        "public_id": "01a037a1-c356-770b-8e62-e018780e2bb5",
        "storage_key": "property/6767906449167177/01a037a1-c356-770b-8e62-e018780e2bb5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of Brighton Woods Apartment Homes, featuring the property's signage and building facade.",
      "link": "false",
      "alt_text": "Lush Brighton Woods apartment community exterior on a sunny day featuring a two-story beige and green building framed by mature trees and manicured landscaping. A prominent leasing center sign with orange lettering stands near the front walkway, bordered by neat red rock mulch, shrubs, and a bright green well-kept lawn.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Brighton-Woods_Favorites%20(30).jpg"
    },
    {
      "id": "ec_157858828dc513c16c5cc422",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021c-8b8c-734e-838e-054d46448cca.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with red doors and balconies, surrounded by trees.",
        "public_id": "019d021c-8b8c-734e-838e-054d46448cca",
        "storage_key": "property/6767906449167177/019d021c-8b8c-734e-838e-054d46448cca.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover comfortable living in these apartment buildings, featuring charming exteriors with red accents and convenient balconies. Ample parking and lush greenery create a welcoming atmosphere.",
      "link": "false",
      "alt_text": "A sunny Brighton Woods community courtyard with two matching two-story apartment buildings featuring tan siding, red trim doors, and small balconies facing a wide parking area. A few cars are parked to the right, and tall evergreens and leafy trees frame the property beneath a bright blue sky dotted with soft white clouds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Brighton-Woods_Favorites%20(17).JPG"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_20609a44-4127-4650-b727-9c94fa8d4b24",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Waffles and Whatnot",
      "poi_type": "Restaurants",
      "poi_address": "500 Muldoon Rd #5, Anchorage, AK 99504, USA",
      "poi_short_description": "Inclusive restaurant serving signature waffles and flavorful chicken dishes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-89dc-75f5-8db7-1b95087450d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412d-89dc-75f5-8db7-1b95087450d3",
        "storage_key": "property/6767906449167177/01a1412d-89dc-75f5-8db7-1b95087450d3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.wafflesandwhatnot.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1484971096063094007&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "waffles-and-whatnot",
      "poi_latitude": "61.217929899999994",
      "poi_longitude": "-149.7342847",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-2f14-74e8-a3c9-9605a43fa7e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-2f14-74e8-a3c9-9605a43fa7e8",
        "storage_key": "property/6767906449167177/019d021d-2f14-74e8-a3c9-9605a43fa7e8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJawFM3gSXyFYR9yyQGlitmxQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_a103d32f-4af2-416f-a3ea-7c10c5c9d245",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Samurai Sushi",
      "poi_type": "Restaurants",
      "poi_address": "1265 Muldoon Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "Intricately presented special rolls & classic Japanese dishes (plus drinks) in a relaxed atmosphere.",
      "poi_long_description": "Intricately presented special rolls & classic Japanese dishes (plus drinks) in a relaxed atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-918e-7188-97e8-c9ca614e73ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412d-918e-7188-97e8-c9ca614e73ec",
        "storage_key": "property/6767906449167177/01a1412d-918e-7188-97e8-c9ca614e73ec.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.aksamuraisushi.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9114186615394182646&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "samurai-sushi",
      "poi_latitude": "61.2101675",
      "poi_longitude": "-149.7327376",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-332-1020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-2f14-74e8-a3c9-9605a43fa7e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-2f14-74e8-a3c9-9605a43fa7e8",
        "storage_key": "property/6767906449167177/019d021d-2f14-74e8-a3c9-9605a43fa7e8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjx5zSKOWyFYR9qUwC3AYfH4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_a9c4c6ba-316b-4a59-a7a6-c406e2895492",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "My Shawarma House",
      "poi_type": "Restaurants",
      "poi_address": "6311 DeBarr Rd #L3, Anchorage, AK 99504, USA",
      "poi_short_description": "Family-owned Mediterranean restaurant serving flavorful Halal shawarma wraps and plates.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-8966-70b2-8028-1a642dc3f6c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412d-8966-70b2-8028-1a642dc3f6c8",
        "storage_key": "property/6767906449167177/01a1412d-8966-70b2-8028-1a642dc3f6c8.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://food.orders.co/zgq83dmk/menu",
      "poi_directions_map_url": "https://maps.google.com/?cid=1255758554656389331&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "my-shawarma-house",
      "poi_latitude": "61.21047659999999",
      "poi_longitude": "-149.76223860000002",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 907-677-0775",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-2f14-74e8-a3c9-9605a43fa7e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-2f14-74e8-a3c9-9605a43fa7e8",
        "storage_key": "property/6767906449167177/019d021d-2f14-74e8-a3c9-9605a43fa7e8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW8y6RgCXyFYR07jzjcBZbRE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_ee6d8531-9e8b-4d9e-9583-ee5a037631f8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Palermo Pizza & Phillys",
      "poi_type": "Restaurants",
      "poi_address": "6406 DeBarr Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "Casual pizza restaurant serving homemade pizzas and Philly cheesesteaks.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-8971-75e0-a64b-6399949edea2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412d-8971-75e0-a64b-6399949edea2",
        "storage_key": "property/6767906449167177/01a1412d-8971-75e0-a64b-6399949edea2.webp",
        "width": 1164,
        "height": 1280
      },
      "poi_business_url": "http://www.palermopizzaak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6219864599423379220&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "palermo-pizza--phillys",
      "poi_latitude": "61.2093259",
      "poi_longitude": "-149.7612916",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 907-334-3354",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-2f14-74e8-a3c9-9605a43fa7e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-2f14-74e8-a3c9-9605a43fa7e8",
        "storage_key": "property/6767906449167177/019d021d-2f14-74e8-a3c9-9605a43fa7e8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJzhg2ZOWyFYRFGeoH-ZlUVY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_fde8af36-5022-4f3f-ad38-1870c5d309d8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Snow City Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1034 W 4th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Locals call ahead to reserve a seat at this bright eatery serving creative breakfast & lunch fare.",
      "poi_long_description": "Locals call ahead to reserve a seat at this bright eatery serving creative breakfast & lunch fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-8c88-70b9-9f78-de3632ebf04e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412d-8c88-70b9-9f78-de3632ebf04e",
        "storage_key": "property/6767906449167177/01a1412d-8c88-70b9-9f78-de3632ebf04e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.snowcitycafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2005746570144512581&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "snow-city-cafe",
      "poi_latitude": "61.2184015",
      "poi_longitude": "-149.9033331",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 907-272-2489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-2f1b-707b-9289-bc556dadce65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-2f1b-707b-9289-bc556dadce65",
        "storage_key": "property/6767906449167177/019d021d-2f1b-707b-9289-bc556dadce65.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJQcnnU4G9yFYRRfrr7uDX1Rs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_0c5f9f62-4ad5-46c6-807f-4e00fa9551ed",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Moose's Tooth Pub & Pizzeria",
      "poi_type": "Restaurants",
      "poi_address": "3300 Old Seward Hwy, Anchorage, AK 99503, USA",
      "poi_short_description": "Inventive pizzas & house-brewed beer served in a bustling, colorful hangout with psychedelic art.",
      "poi_long_description": "Inventive pizzas & house-brewed beer served in a bustling, colorful hangout with psychedelic art.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412b-5b32-75ef-bd3d-d79fa083b732.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412b-5b32-75ef-bd3d-d79fa083b732",
        "storage_key": "property/6767906449167177/01a1412b-5b32-75ef-bd3d-d79fa083b732.webp",
        "width": 1280,
        "height": 889
      },
      "poi_business_url": "https://www.moosestoothak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15494600602096929900&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mooses-tooth-pub--pizzeria",
      "poi_latitude": "61.1905009",
      "poi_longitude": "-149.86910369999998",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-258-2537",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-2f14-74e8-a3c9-9605a43fa7e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-2f14-74e8-a3c9-9605a43fa7e8",
        "storage_key": "property/6767906449167177/019d021d-2f14-74e8-a3c9-9605a43fa7e8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3wBgzrmXyFYRbIyKWCfhB9c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_074a8b0a-9252-4759-8ab6-035ecbd6bb25",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Glacier Brewhouse",
      "poi_type": "Restaurants",
      "poi_address": "737 W 5th Ave #110, Anchorage, AK 99501, USA",
      "poi_short_description": "Boisterous, wood-dominated dining room with local seafood, wood-grilled meats & house-brewed beer.",
      "poi_long_description": "Boisterous, wood-dominated dining room with local seafood, wood-grilled meats & house-brewed beer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412b-5ad0-737a-b917-cfbfeb5667a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412b-5ad0-737a-b917-cfbfeb5667a7",
        "storage_key": "property/6767906449167177/01a1412b-5ad0-737a-b917-cfbfeb5667a7.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://glacierbrewhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7378027105723896693&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "glacier-brewhouse",
      "poi_latitude": "61.21784590000001",
      "poi_longitude": "-149.8964654",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-274-2739",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-2f14-74e8-a3c9-9605a43fa7e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-2f14-74e8-a3c9-9605a43fa7e8",
        "storage_key": "property/6767906449167177/019d021d-2f14-74e8-a3c9-9605a43fa7e8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7bXHMYe9yFYRdVPg648EZGY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_d9da1987-20c0-4187-9a1d-f3d2c5a920e4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "49th State Brewing - Anchorage",
      "poi_type": "Restaurants",
      "poi_address": "717 W 3rd Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Lively brewpub with a rooftop patio doling out creative bar bites & housemade ales.",
      "poi_long_description": "Lively brewpub with a rooftop patio doling out creative bar bites & housemade ales.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412b-6116-75ba-8e84-176ac97ba76b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412b-6116-75ba-8e84-176ac97ba76b",
        "storage_key": "property/6767906449167177/01a1412b-6116-75ba-8e84-176ac97ba76b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://49thstatebrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5965183622877416450&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "49th-state-brewing---anchorage",
      "poi_latitude": "61.21962659999999",
      "poi_longitude": "-149.89591679999998",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-277-7727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-2f14-74e8-a3c9-9605a43fa7e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-2f14-74e8-a3c9-9605a43fa7e8",
        "storage_key": "property/6767906449167177/019d021d-2f14-74e8-a3c9-9605a43fa7e8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJcRhn_Ya9yFYRAgyWbeaWyFI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_0af9c389-2537-4bbc-ba59-5589e02eb36a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Simon & Seafort's Saloon & Grill",
      "poi_type": "Restaurants",
      "poi_address": "420 L St, Anchorage, AK 99501, USA",
      "poi_short_description": "Inviting dining room with sweeping views, serving aged steak, fresh seafood & weekend brunch.",
      "poi_long_description": "Inviting dining room with sweeping views, serving aged steak, fresh seafood & weekend brunch.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-8740-748d-9203-5a9a9196bd0f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412d-8740-748d-9203-5a9a9196bd0f",
        "storage_key": "property/6767906449167177/01a1412d-8740-748d-9203-5a9a9196bd0f.webp",
        "width": 600,
        "height": 441
      },
      "poi_business_url": "https://www.simonandseaforts.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1709221909627021300&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "simon--seaforts-saloon--grill",
      "poi_latitude": "61.2179842",
      "poi_longitude": "-149.9043854",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-274-3502",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-2f14-74e8-a3c9-9605a43fa7e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-2f14-74e8-a3c9-9605a43fa7e8",
        "storage_key": "property/6767906449167177/019d021d-2f14-74e8-a3c9-9605a43fa7e8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJn5_VXoG9yFYR9CeiXUVguBc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_962d87ec-df14-4041-93b3-a467c95228d4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Sullivan's Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "320 W 5th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Steakhouse chain serving beef, seafood & cocktails in swanky surrounds with live music.",
      "poi_long_description": "Steakhouse chain serving beef, seafood & cocktails in swanky surrounds with live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-890a-76da-b205-416127d5e3f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412d-890a-76da-b205-416127d5e3f2",
        "storage_key": "property/6767906449167177/01a1412d-890a-76da-b205-416127d5e3f2.webp",
        "width": 1280,
        "height": 638
      },
      "poi_business_url": "https://sullivanssteakhouse.com/anchorage/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14639881408127896693&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sullivans-steakhouse",
      "poi_latitude": "61.21736999999999",
      "poi_longitude": "-149.88782999999998",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-258-2882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-2f14-74e8-a3c9-9605a43fa7e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-2f14-74e8-a3c9-9605a43fa7e8",
        "storage_key": "property/6767906449167177/019d021d-2f14-74e8-a3c9-9605a43fa7e8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJH0jnvSmWyFYRdQxPRZNOK8s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_a6fbbf44-a2df-4d38-87c7-aa6652453a48",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Whisky & Ramen",
      "poi_type": "Restaurants",
      "poi_address": "436 W 4th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Upscale ramen restaurant and whiskey bar serving craft cocktails and artisanal ramen.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-8d5d-716d-82b1-adc0e7f68109.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412d-8d5d-716d-82b1-adc0e7f68109",
        "storage_key": "property/6767906449167177/01a1412d-8d5d-716d-82b1-adc0e7f68109.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.whiskyandramen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13513374528639682359&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whisky--ramen",
      "poi_latitude": "61.2182843",
      "poi_longitude": "-149.89091919999998",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-717-0737",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-2f14-74e8-a3c9-9605a43fa7e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-2f14-74e8-a3c9-9605a43fa7e8",
        "storage_key": "property/6767906449167177/019d021d-2f14-74e8-a3c9-9605a43fa7e8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJe-Lt7JKXyFYRN0dhcIkmibs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ramen_restaurant"
    },
    {
      "id": "custom_ebe5dc68-81d9-4e6e-b480-d26cd99075f6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "F Street Station",
      "poi_type": "Restaurants",
      "poi_address": "325 F St, Anchorage, AK 99501, USA",
      "poi_short_description": "Low-key bar serving up seafood & draft beer, plus a weekend brunch with a popular eggs Benedict.",
      "poi_long_description": "Low-key bar serving up seafood & draft beer, plus a weekend brunch with a popular eggs Benedict.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-9568-747d-b7c6-78fec4a519db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412d-9568-747d-b7c6-78fec4a519db",
        "storage_key": "property/6767906449167177/01a1412d-9568-747d-b7c6-78fec4a519db.webp",
        "width": 1280,
        "height": 831
      },
      "poi_business_url": "https://fstreetstation.website/",
      "poi_directions_map_url": "https://maps.google.com/?cid=497107031803204211&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "f-street-station",
      "poi_latitude": "61.2189375",
      "poi_longitude": "-149.8931451",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-272-5196",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-2f14-74e8-a3c9-9605a43fa7e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-2f14-74e8-a3c9-9605a43fa7e8",
        "storage_key": "property/6767906449167177/019d021d-2f14-74e8-a3c9-9605a43fa7e8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtc6fbYe9yFYRc5L6LTYU5gY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_101dd891-c2ae-44ca-ac37-da63eb42b308",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Gumbo House",
      "poi_type": "Restaurants",
      "poi_address": "508 W 6th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Relaxed Cajun restaurant with patio lawn seating, serving up gumbo for eat-in or take-out.",
      "poi_long_description": "Relaxed Cajun restaurant with patio lawn seating, serving up gumbo for eat-in or take-out.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-9590-74dd-9b28-16a12874cff9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412d-9590-74dd-9b28-16a12874cff9",
        "storage_key": "property/6767906449167177/01a1412d-9590-74dd-9b28-16a12874cff9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.gumbohousealaska.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7394110026326867887&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gumbo-house",
      "poi_latitude": "61.216472499999995",
      "poi_longitude": "-149.892066",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-222-2930",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-2f14-74e8-a3c9-9605a43fa7e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-2f14-74e8-a3c9-9605a43fa7e8",
        "storage_key": "property/6767906449167177/019d021d-2f14-74e8-a3c9-9605a43fa7e8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJcdfSYCqWyFYRr_9dreQnnWY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cajun_restaurant"
    },
    {
      "id": "custom_fd8747aa-61a5-4965-9ba2-724c6528740d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Humpy's Great Alaskan Alehouse",
      "poi_type": "Restaurants",
      "poi_address": "610 W 6th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Live music & trivia in a laid-back hangout serving seafood & pub grub, plus a huge beer selection.",
      "poi_long_description": "Live music & trivia in a laid-back hangout serving seafood & pub grub, plus a huge beer selection.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-73ef-7025-aae2-eded212e000c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021d-73ef-7025-aae2-eded212e000c",
        "storage_key": "property/6767906449167177/019d021d-73ef-7025-aae2-eded212e000c.webp",
        "width": 904,
        "height": 720
      },
      "poi_business_url": "https://www.humpysalaska.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2859243613023281808&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "humpys-great-alaskan-alehouse",
      "poi_latitude": "61.216342",
      "poi_longitude": "-149.894083",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-276-2337",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-2f14-74e8-a3c9-9605a43fa7e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-2f14-74e8-a3c9-9605a43fa7e8",
        "storage_key": "property/6767906449167177/019d021d-2f14-74e8-a3c9-9605a43fa7e8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ14LWxYC9yFYRkKKOyOoSric",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_64bec22e-4fc6-4bba-a77c-10ea3c9c0e3a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Anchorage Halal Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "6311 DeBarr Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-9a9e-779b-b1fd-84a241576088.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412d-9a9e-779b-b1fd-84a241576088",
        "storage_key": "property/6767906449167177/01a1412d-9a9e-779b-b1fd-84a241576088.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "https://food.orders.co/zgq83dmk",
      "poi_directions_map_url": "https://maps.google.com/?cid=14251559700285562051&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-halal-market",
      "poi_latitude": "61.210538",
      "poi_longitude": "-149.76223869999998",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 907-677-0775",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-37cc-7724-adec-e35d7055db18.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-37cc-7724-adec-e35d7055db18",
        "storage_key": "property/6767906449167177/019d021d-37cc-7724-adec-e35d7055db18.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ19hY4mGXyFYRwxzLFgq2x8U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_234af931-fe0e-4af4-a3a5-37f0c15ad5e6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Mom & Pops Grocery",
      "poi_type": "Shopping & Retail",
      "poi_address": "6307 DeBarr Rd # E, Anchorage, AK 99504, USA",
      "poi_short_description": "Convenient local grocery store offering snacks and affordable tobacco products.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-9a9c-7644-87cb-0a2eaab870da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412d-9a9c-7644-87cb-0a2eaab870da",
        "storage_key": "property/6767906449167177/01a1412d-9a9c-7644-87cb-0a2eaab870da.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11466721338073549282&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mom--pops-grocery",
      "poi_latitude": "61.21004919999999",
      "poi_longitude": "-149.7631213",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 907-333-6667",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-37cc-7724-adec-e35d7055db18.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-37cc-7724-adec-e35d7055db18",
        "storage_key": "property/6767906449167177/019d021d-37cc-7724-adec-e35d7055db18.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnwLdf5GWyFYR4glEvk36IZ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_2dd8e182-7afb-49da-a4e3-b3e3fe5615fc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Carrs",
      "poi_type": "Shopping & Retail",
      "poi_address": "5600 DeBarr Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "Longtime supermarket chain with brand-name & house-label groceries, plus a deli, bakery & pharmacy.",
      "poi_long_description": "Longtime supermarket chain with brand-name & house-label groceries, plus a deli, bakery & pharmacy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021c-cb50-7676-ab69-07d3aaea72dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-cb50-7676-ab69-07d3aaea72dd",
        "storage_key": "property/6767906449167177/019d021c-cb50-7676-ab69-07d3aaea72dd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://local.carrsqc.com/ak/anchorage/5600-debarr-rd.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=4664412945575878724&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carrs",
      "poi_latitude": "61.2081423",
      "poi_longitude": "-149.77701720000002",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 907-339-0900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-37cc-7724-adec-e35d7055db18.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-37cc-7724-adec-e35d7055db18",
        "storage_key": "property/6767906449167177/019d021d-37cc-7724-adec-e35d7055db18.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcVWUPI2WyFYRRKDIYtxSu0A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_96a12b50-fe51-485d-85d7-dee88c023578",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1200 N Muldoon Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-9cfb-7046-8b20-717d3c76f80d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412d-9cfb-7046-8b20-717d3c76f80d",
        "storage_key": "property/6767906449167177/01a1412d-9cfb-7046-8b20-717d3c76f80d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cvs.com/store-locator/anchorage-ak-pharmacies/1200-n-muldoon-rd-anchorage-ak-99504/storeid=17435?WT.mc_id=LS_GOOGLE_RX_17435",
      "poi_directions_map_url": "https://maps.google.com/?cid=2401999348130175879&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "61.22616159999999",
      "poi_longitude": "-149.7460372",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-332-1004",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-3c25-7218-a415-5212f9c388ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-3c25-7218-a415-5212f9c388ba",
        "storage_key": "property/6767906449167177/019d021d-3c25-7218-a415-5212f9c388ba.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvwOC3yeUyFYRh9sESK6dVSE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_5319c95a-b671-4df4-a668-bad08dace5f2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Fred Meyer",
      "poi_type": "Shopping & Retail",
      "poi_address": "7701 DeBarr Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "Longtime retail chain for groceries, apparel & furniture, plus toys, electronics, housewares & more.",
      "poi_long_description": "Longtime retail chain for groceries, apparel & furniture, plus toys, electronics, housewares & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021c-d3f5-751f-ab64-018c650995b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-d3f5-751f-ab64-018c650995b5",
        "storage_key": "property/6767906449167177/019d021c-d3f5-751f-ab64-018c650995b5.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.fredmeyer.com/stores/grocery/ak/anchorage/muldoon/701/00018?cid=loc_70100018_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=6875232166619000959&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fred-meyer",
      "poi_latitude": "61.211520799999995",
      "poi_longitude": "-149.7367644",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-269-1700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-37cc-7724-adec-e35d7055db18.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-37cc-7724-adec-e35d7055db18",
        "storage_key": "property/6767906449167177/019d021d-37cc-7724-adec-e35d7055db18.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1aeEJaOWyFYRfzCqnzq7aV8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_79e62a6a-741c-49e7-82cb-1182bf27753d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "7405 DeBarr Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "One-stop department store offering a wide selection of household items and electronics.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021c-d289-729b-8802-4160fff1a5cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-d289-729b-8802-4160fff1a5cd",
        "storage_key": "property/6767906449167177/019d021c-d289-729b-8802-4160fff1a5cd.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/4359-anchorage-ak/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=18253871179416217585&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "61.2118328",
      "poi_longitude": "-149.7435267",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-339-9039",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-3396-733f-bb18-2cd95942572d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-3396-733f-bb18-2cd95942572d",
        "storage_key": "property/6767906449167177/019d021d-3396-733f-bb18-2cd95942572d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJI7PFF5iWyFYR8SfY4B_HUv0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_1c23cc1c-c42c-4996-aaba-42db61691239",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Flowers By June",
      "poi_type": "Shopping & Retail",
      "poi_address": "6311 DeBarr Rd Q, Anchorage, AK 99504, USA",
      "poi_short_description": "Family-owned Anchorage florist offering fresh, custom floral arrangements and convenient online ordering.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-9fb0-719e-8531-32e9fada879c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412d-9fb0-719e-8531-32e9fada879c",
        "storage_key": "property/6767906449167177/01a1412d-9fb0-719e-8531-32e9fada879c.webp",
        "width": 961,
        "height": 1280
      },
      "poi_business_url": "https://www.flowersbyjune.com/?utm_source=google&utm_medium=gbp&y_source=1_ODU4MDc2NC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=3675337497952888941&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "flowers-by-june",
      "poi_latitude": "61.210538",
      "poi_longitude": "-149.76223869999998",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 907-337-1551",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-3396-733f-bb18-2cd95942572d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-3396-733f-bb18-2cd95942572d",
        "storage_key": "property/6767906449167177/019d021d-3396-733f-bb18-2cd95942572d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJNxhC0ZOWyFYRbagnS_trATM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "florist"
    },
    {
      "id": "custom_8073d9ac-1d2c-46fa-8c8d-44718fb582f4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Rent-A-Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "5600 DeBarr Rd #120, Anchorage, AK 99504, USA",
      "poi_short_description": "Chain outlet, offering furniture, home appliances and electronics for rental.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-9da6-72ff-94f9-c378b9037dba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412d-9da6-72ff-94f9-c378b9037dba",
        "storage_key": "property/6767906449167177/01a1412d-9da6-72ff-94f9-c378b9037dba.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.rentacenter.com/location/2538/?utm_source=google&utm_medium=organic&utm_campaign=localmaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=8041198336521459312&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rent-a-center",
      "poi_latitude": "61.2082476",
      "poi_longitude": "-149.77609099999998",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 907-290-5253",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-3396-733f-bb18-2cd95942572d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-3396-733f-bb18-2cd95942572d",
        "storage_key": "property/6767906449167177/019d021d-3396-733f-bb18-2cd95942572d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJcVWUPI2WyFYRcNbScEgTmG8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_ef1190e2-2d84-4364-8139-0bbbf7dd1264",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Oaken Keg",
      "poi_type": "Shopping & Retail",
      "poi_address": "5600 DeBarr Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-9e08-72af-8893-067f88e2a73f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412d-9e08-72af-8893-067f88e2a73f",
        "storage_key": "property/6767906449167177/01a1412d-9e08-72af-8893-067f88e2a73f.webp",
        "width": 1217,
        "height": 685
      },
      "poi_business_url": "https://www.carrsqc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7233059360206340346&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oaken-keg",
      "poi_latitude": "61.2082476",
      "poi_longitude": "-149.77609099999998",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 907-339-0900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-3396-733f-bb18-2cd95942572d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-3396-733f-bb18-2cd95942572d",
        "storage_key": "property/6767906449167177/019d021d-3396-733f-bb18-2cd95942572d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ9yO1oTqXyFYR-sBpbCr9YGQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "liquor_store"
    },
    {
      "id": "custom_7ac58d2e-935b-4de7-b08d-33d12b9e9536",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Ptarmigan Elementary School",
      "poi_type": "Education",
      "poi_address": "888 Edward St, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-a339-771f-93a1-e5ccd7c089cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412d-a339-771f-93a1-e5ccd7c089cf",
        "storage_key": "property/6767906449167177/01a1412d-a339-771f-93a1-e5ccd7c089cf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.asdk12.org/ptarmigan",
      "poi_directions_map_url": "https://maps.google.com/?cid=8593156068931633944&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ptarmigan-elementary-school",
      "poi_latitude": "61.21426769999999",
      "poi_longitude": "-149.7648965",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-742-0400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-3790-70b8-b0d6-4e43d12cbd78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-3790-70b8-b0d6-4e43d12cbd78",
        "storage_key": "property/6767906449167177/019d021d-3790-70b8-b0d6-4e43d12cbd78.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-aC30o-WyFYRGIMpjOoFQXc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_d294d9f5-5050-4698-92c7-469a9ba5925a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Central Middle School of Science",
      "poi_type": "Education",
      "poi_address": "1405 E St, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-a2b6-7417-ad74-e8e593e19097.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412d-a2b6-7417-ad74-e8e593e19097",
        "storage_key": "property/6767906449167177/01a1412d-a2b6-7417-ad74-e8e593e19097.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://central.asdk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12980891005085165217&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-middle-school-of-science",
      "poi_latitude": "61.2083004",
      "poi_longitude": "-149.8893498",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-742-5100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-3790-70b8-b0d6-4e43d12cbd78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-3790-70b8-b0d6-4e43d12cbd78",
        "storage_key": "property/6767906449167177/019d021d-3790-70b8-b0d6-4e43d12cbd78.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQ9ZwCpOWyFYRoSYq6pdjJbQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_21a1281e-9928-4320-b806-039ae5f85962",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Bartlett High School",
      "poi_type": "Education",
      "poi_address": "1101 Golden Bear Dr, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-a720-7448-9ede-12d9c881971f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412d-a720-7448-9ede-12d9c881971f",
        "storage_key": "property/6767906449167177/01a1412d-a720-7448-9ede-12d9c881971f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.asdk12.org/bartlett",
      "poi_directions_map_url": "https://maps.google.com/?cid=846529779845035471&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bartlett-high-school",
      "poi_latitude": "61.2325666",
      "poi_longitude": "-149.733236",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-742-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-3790-70b8-b0d6-4e43d12cbd78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-3790-70b8-b0d6-4e43d12cbd78",
        "storage_key": "property/6767906449167177/019d021d-3790-70b8-b0d6-4e43d12cbd78.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJa5cL-SWUyFYRz_Vzg1l6vws",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_a8b1bdd9-41bc-4448-bdb8-8f886fa7049a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Clark Middle School",
      "poi_type": "Education",
      "poi_address": "150 Bragaw St, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-a922-7519-9028-1d6740f0699e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412d-a922-7519-9028-1d6740f0699e",
        "storage_key": "property/6767906449167177/01a1412d-a922-7519-9028-1d6740f0699e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://clark.asdk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3194748686231896837&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clark-middle-school",
      "poi_latitude": "61.2228308",
      "poi_longitude": "-149.8110892",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-742-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-3790-70b8-b0d6-4e43d12cbd78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-3790-70b8-b0d6-4e43d12cbd78",
        "storage_key": "property/6767906449167177/019d021d-3790-70b8-b0d6-4e43d12cbd78.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGQm1AG-WyFYRBYN_7QAHViw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_e5dc17ba-b694-45df-9519-54707c726017",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "University of Alaska Anchorage",
      "poi_type": "Education",
      "poi_address": "3211 Providence Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021c-e00c-7021-825c-ef4b491e0510.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-e00c-7021-825c-ef4b491e0510",
        "storage_key": "property/6767906449167177/019d021c-e00c-7021-825c-ef4b491e0510.webp",
        "width": 672,
        "height": 400
      },
      "poi_business_url": "https://www.uaa.alaska.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2963319407001083725&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-alaska-anchorage",
      "poi_latitude": "61.1910421",
      "poi_longitude": "-149.81955979999998",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-786-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-3790-70b8-b0d6-4e43d12cbd78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-3790-70b8-b0d6-4e43d12cbd78",
        "storage_key": "property/6767906449167177/019d021d-3790-70b8-b0d6-4e43d12cbd78.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8bmy6gCXyFYRTR9S4kzTHyk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_4361dd8b-731e-4d39-84ea-994557c23819",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Alaska Pacific University",
      "poi_type": "Education",
      "poi_address": "4101 University Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021c-e3dd-750d-b2b4-cee6cc31183c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-e3dd-750d-b2b4-cee6cc31183c",
        "storage_key": "property/6767906449167177/019d021c-e3dd-750d-b2b4-cee6cc31183c.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.alaskapacific.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11603594146335186940&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-pacific-university",
      "poi_latitude": "61.1892616",
      "poi_longitude": "-149.8065058",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 800-252-7528",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-3790-70b8-b0d6-4e43d12cbd78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-3790-70b8-b0d6-4e43d12cbd78",
        "storage_key": "property/6767906449167177/019d021d-3790-70b8-b0d6-4e43d12cbd78.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsU8plvyWyFYR_F8cymU_CKE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_37bc5072-65dd-4a08-9827-7907dfddb3c7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Northern Lights Preschool & Child Care",
      "poi_type": "Education",
      "poi_address": "703 W Northern Lights Blvd Ste 200, Anchorage, AK 99503, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021c-dd05-769c-bb07-52bb58471e5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-dd05-769c-bb07-52bb58471e5b",
        "storage_key": "property/6767906449167177/019d021c-dd05-769c-bb07-52bb58471e5b.webp",
        "width": 1000,
        "height": 562
      },
      "poi_business_url": "http://www.nlpkak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6040540510000710581&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northern-lights-preschool--child-care",
      "poi_latitude": "61.195476",
      "poi_longitude": "-149.8967867",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-274-2040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-3790-70b8-b0d6-4e43d12cbd78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-3790-70b8-b0d6-4e43d12cbd78",
        "storage_key": "property/6767906449167177/019d021d-3790-70b8-b0d6-4e43d12cbd78.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJfvXzdqXyFYRtQPz9ZZP1FM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_43cc27f5-27d2-4307-9d4e-da86a66e4e99",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Pacific Northern Academy",
      "poi_type": "Education",
      "poi_address": "2511 Sentry Dr, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.pacificnorthern.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=206734834740584442&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pacific-northern-academy",
      "poi_latitude": "61.1333745",
      "poi_longitude": "-149.8356213",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-3790-70b8-b0d6-4e43d12cbd78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-3790-70b8-b0d6-4e43d12cbd78",
        "storage_key": "property/6767906449167177/019d021d-3790-70b8-b0d6-4e43d12cbd78.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJW969xGeWyFYR-l9pozx43gI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_1f408c1b-a187-4fca-a072-914907915db0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Mountain City Christian Academy",
      "poi_type": "Education",
      "poi_address": "6575 E Northern Lights Blvd, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-b2dc-7788-975c-314dca2b1e3b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412d-b2dc-7788-975c-314dca2b1e3b",
        "storage_key": "property/6767906449167177/01a1412d-b2dc-7788-975c-314dca2b1e3b.webp",
        "width": 1280,
        "height": 1024
      },
      "poi_business_url": "http://www.mountaincitychristian.academy/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14343842628401888106&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mountain-city-christian-academy",
      "poi_latitude": "61.1963032",
      "poi_longitude": "-149.7584713",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-337-9575",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-3790-70b8-b0d6-4e43d12cbd78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-3790-70b8-b0d6-4e43d12cbd78",
        "storage_key": "property/6767906449167177/019d021d-3790-70b8-b0d6-4e43d12cbd78.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_____z-SyFYRavv_o9-QD8c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_b0dad8d7-6dad-4a5c-a37f-6f78730c2f89",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Polaris K-12 School",
      "poi_type": "Education",
      "poi_address": "6200 Ashwood St, Anchorage, AK 99507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-a972-7688-a0dc-f2235208cc74.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412d-a972-7688-a0dc-f2235208cc74",
        "storage_key": "property/6767906449167177/01a1412d-a972-7688-a0dc-f2235208cc74.webp",
        "width": 1032,
        "height": 581
      },
      "poi_business_url": "http://polaris.asdk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18212036476561568338&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "polaris-k-12-school",
      "poi_latitude": "61.164478300000006",
      "poi_longitude": "-149.85386480000005",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-742-8700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-3790-70b8-b0d6-4e43d12cbd78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-3790-70b8-b0d6-4e43d12cbd78",
        "storage_key": "property/6767906449167177/019d021d-3790-70b8-b0d6-4e43d12cbd78.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmQMbsneXyFYRUrLoFa8mvvw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_08a3e2e1-74ad-40b3-8698-9c2ecdb9b776",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Cyrano's Theatre Company",
      "poi_type": "Entertainment",
      "poi_address": "3800 DeBarr Rd, Anchorage, AK 99508, USA",
      "poi_short_description": "Black-box theater staging a play a month, ranging from Shakespearean classics to original works.",
      "poi_long_description": "Black-box theater staging a play a month, ranging from Shakespearean classics to original works.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-aa3f-704d-b4e4-b11a107bf12f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412d-aa3f-704d-b4e4-b11a107bf12f",
        "storage_key": "property/6767906449167177/01a1412d-aa3f-704d-b4e4-b11a107bf12f.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.cyranos.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13374691035069826416&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cyranos-theatre-company",
      "poi_latitude": "61.2092959",
      "poi_longitude": "-149.80971449999998",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-274-2599",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-e23a-72b1-9233-b63453bd976c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1412d-e23a-72b1-9233-b63453bd976c",
        "storage_key": "property/6767906449167177/01a1412d-e23a-72b1-9233-b63453bd976c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW9JAzimWyFYRcEXwXaJynLk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_d590099c-cfec-43d6-b2c0-c4056d7bd239",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Alaska Native Heritage Center",
      "poi_type": "Entertainment",
      "poi_address": "8800 Heritage Center Dr, Anchorage, AK 99504, USA",
      "poi_short_description": "Exhibits, films & demonstrations of native culture, plus a woodland area with traditional dwellings.",
      "poi_long_description": "Exhibits, films & demonstrations of native culture, plus a woodland area with traditional dwellings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021c-e684-764a-95c5-7bbadde29e80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-e684-764a-95c5-7bbadde29e80",
        "storage_key": "property/6767906449167177/019d021c-e684-764a-95c5-7bbadde29e80.webp",
        "width": 992,
        "height": 744
      },
      "poi_business_url": "http://www.alaskanative.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2030269464598956769&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-native-heritage-center",
      "poi_latitude": "61.2327673",
      "poi_longitude": "-149.7172142",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-330-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-37be-7454-b8c3-268546ccdee0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-37be-7454-b8c3-268546ccdee0",
        "storage_key": "property/6767906449167177/019d021d-37be-7454-b8c3-268546ccdee0.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJa0B1BT2UyFYR4Uq-O1L3LBw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cultural_center"
    },
    {
      "id": "custom_f494f41f-3518-44f0-ad49-ef7c54d6dc89",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Anchorage Museum",
      "poi_type": "Entertainment",
      "poi_address": "625 C St, Anchorage, AK 99501, USA",
      "poi_short_description": "Alaskan artifacts & artworks, plus a kid-friendly, hands-on science center & planetarium.",
      "poi_long_description": "Alaskan artifacts & artworks, plus a kid-friendly, hands-on science center & planetarium.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412b-60ab-70b6-a753-4b82993c3eb4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412b-60ab-70b6-a753-4b82993c3eb4",
        "storage_key": "property/6767906449167177/01a1412b-60ab-70b6-a753-4b82993c3eb4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.anchoragemuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6288654669058341295&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-museum",
      "poi_latitude": "61.2162281",
      "poi_longitude": "-149.8855791",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-929-9200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-37be-7454-b8c3-268546ccdee0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-37be-7454-b8c3-268546ccdee0",
        "storage_key": "property/6767906449167177/019d021d-37be-7454-b8c3-268546ccdee0.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJjUPnbCmWyFYRr_lSUBrKRVc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_e5d1ac2f-40d2-4164-9e7f-b53475e5af3a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Alaska Aviation Museum",
      "poi_type": "Entertainment",
      "poi_address": "4721 Aircraft Dr, Anchorage, AK 99502, USA",
      "poi_short_description": "Historic aircraft (which guests may see being restored), plus exhibits, films & a flight simulator.",
      "poi_long_description": "Historic aircraft (which guests may see being restored), plus exhibits, films & a flight simulator.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-ac97-72dd-8f70-d5518b8bd7ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412d-ac97-72dd-8f70-d5518b8bd7ed",
        "storage_key": "property/6767906449167177/01a1412d-ac97-72dd-8f70-d5518b8bd7ed.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.alaskaairmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15162667059188171085&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-aviation-museum",
      "poi_latitude": "61.1793565",
      "poi_longitude": "-149.97190659999998",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 14 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 907-248-5325",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-37be-7454-b8c3-268546ccdee0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-37be-7454-b8c3-268546ccdee0",
        "storage_key": "property/6767906449167177/019d021d-37be-7454-b8c3-268546ccdee0.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJExnfV029yFYRTYFt5lqdbNI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_a66045c9-85b2-4177-b0b1-9acf02d9726c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Bear Tooth Theatrepub",
      "poi_type": "Entertainment",
      "poi_address": "1230 W 27th Ave, Anchorage, AK 99503, USA",
      "poi_short_description": "2nd-run & indie moviehouse (that also hosts concerts) serving microbrews, wine & casual eats.",
      "poi_long_description": "2nd-run & indie moviehouse (that also hosts concerts) serving microbrews, wine & casual eats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-ad66-715d-926a-59a95c01a00d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412d-ad66-715d-926a-59a95c01a00d",
        "storage_key": "property/6767906449167177/01a1412d-ad66-715d-926a-59a95c01a00d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.beartoothak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10145190151877577635&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bear-tooth-theatrepub",
      "poi_latitude": "61.1959573",
      "poi_longitude": "-149.9070452",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 907-276-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-33c7-713d-8dd4-864a3783b24f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-33c7-713d-8dd4-864a3783b24f",
        "storage_key": "property/6767906449167177/019d021d-33c7-713d-8dd4-864a3783b24f.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJM_p-3NuXyFYRo0t0DbH0yow",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_9621bc40-1eca-45ab-9be1-3ef7836895ea",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Alaska Museum of Science and Nature",
      "poi_type": "Entertainment",
      "poi_address": "201 N Bragaw St, Anchorage, AK 99508, USA",
      "poi_short_description": "Museum exploring Alaska's natural history, with dinosaur fossils & hands-on displays for kids.",
      "poi_long_description": "Museum exploring Alaska's natural history, with dinosaur fossils & hands-on displays for kids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412b-7682-710d-90be-fcd0c4b84500.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412b-7682-710d-90be-fcd0c4b84500",
        "storage_key": "property/6767906449167177/01a1412b-7682-710d-90be-fcd0c4b84500.webp",
        "width": 1280,
        "height": 963
      },
      "poi_business_url": "http://www.alaskamuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16255560840695787410&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-museum-of-science-and-nature",
      "poi_latitude": "61.22514929999999",
      "poi_longitude": "-149.8078589",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-274-2400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-37be-7454-b8c3-268546ccdee0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-37be-7454-b8c3-268546ccdee0",
        "storage_key": "property/6767906449167177/019d021d-37be-7454-b8c3-268546ccdee0.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ99EwrG-WyFYRki9sfnVal-E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_c1668789-50ac-475d-9c72-c93472618662",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Alaska Botanical Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4601 Campbell Airstrip Road, Anchorage, AK 99507, USA",
      "poi_short_description": "Trails guide visitors through a boreal forest to 11 acres of cultivated gardens with native flora.",
      "poi_long_description": "Trails guide visitors through a boreal forest to 11 acres of cultivated gardens with native flora.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412b-7bfd-7518-bdff-8f7dbe868d20.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412b-7bfd-7518-bdff-8f7dbe868d20",
        "storage_key": "property/6767906449167177/01a1412b-7bfd-7518-bdff-8f7dbe868d20.webp",
        "width": 976,
        "height": 662
      },
      "poi_business_url": "http://www.alaskabg.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5929108756512643080&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-botanical-garden",
      "poi_latitude": "61.17777439999999",
      "poi_longitude": "-149.7615572",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-770-3692",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412b-9957-70cc-8e14-a5386ff5ba3b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1412b-9957-70cc-8e14-a5386ff5ba3b",
        "storage_key": "property/6767906449167177/01a1412b-9957-70cc-8e14-a5386ff5ba3b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-wU15deWyFYRCBiYEgBtSFI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_14093b11-77cd-474e-bfec-cc5d55e93675",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Alaska Zoo",
      "poi_type": "Entertainment",
      "poi_address": "4731 O'Malley Rd, Anchorage, AK 99507, USA",
      "poi_short_description": "Zoo exhibiting a wide range of native Alaskan mammals & birds, plus exotics such as tigers & camels.",
      "poi_long_description": "Zoo exhibiting a wide range of native Alaskan mammals & birds, plus exotics such as tigers & camels.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412b-6446-72c4-8518-24585b91a879.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412b-6446-72c4-8518-24585b91a879",
        "storage_key": "property/6767906449167177/01a1412b-6446-72c4-8518-24585b91a879.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.alaskazoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11640787335481525738&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-zoo",
      "poi_latitude": "61.1238025",
      "poi_longitude": "-149.7907",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412b-994e-7687-9dc8-bd4446b4c434.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1412b-994e-7687-9dc8-bd4446b4c434",
        "storage_key": "property/6767906449167177/01a1412b-994e-7687-9dc8-bd4446b4c434.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJH2Yh-ASayFYR6gU-9WdijKE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_016d074e-0c89-4185-9b61-de986cc7ad56",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Alaska Airlines Center",
      "poi_type": "Entertainment",
      "poi_address": "3550 Providence Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "Multi-purpose arena hosting concerts and sporting events.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412b-6554-716c-9ab4-9f301629f419.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412b-6554-716c-9ab4-9f301629f419",
        "storage_key": "property/6767906449167177/01a1412b-6554-716c-9ab4-9f301629f419.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://thealaskaairlinescenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15474101461367454098&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-airlines-center",
      "poi_latitude": "61.1881625",
      "poi_longitude": "-149.81411649999998",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-786-7850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412b-994d-705a-8606-b3aaaaddf22e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1412b-994d-705a-8606-b3aaaaddf22e",
        "storage_key": "property/6767906449167177/01a1412b-994d-705a-8606-b3aaaaddf22e.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJe0jlkwGXyFYRkvkoN0sNv9Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_65ca9332-0dd6-4925-bb55-2f30bff452ac",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Alaska Regional Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "2801 DeBarr Rd, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-20d6-737c-b512-003c4aaac624.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021d-20d6-737c-b512-003c4aaac624",
        "storage_key": "property/6767906449167177/019d021d-20d6-737c-b512-003c4aaac624.webp",
        "width": 911,
        "height": 512
      },
      "poi_business_url": "https://www.alaskaregional.com/?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=1047679142014347636&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-regional-hospital",
      "poi_latitude": "61.2107038",
      "poi_longitude": "-149.8288584",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-276-1131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-3b98-76ba-9930-52bab3b868cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-3b98-76ba-9930-52bab3b868cf",
        "storage_key": "property/6767906449167177/019d021d-3b98-76ba-9930-52bab3b868cf.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJKYPSVUSWyFYRdOlZ-qAaig4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_0ce2d7dd-64fb-4bd5-9129-b67a2cf85f95",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Providence ExpressCare - Tikahtnu Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "1118 N Muldoon Rd Ste 130, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021c-f215-754d-9147-ade4a7e32422.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-f215-754d-9147-ade4a7e32422",
        "storage_key": "property/6767906449167177/019d021c-f215-754d-9147-ade4a7e32422.webp",
        "width": 1173,
        "height": 660
      },
      "poi_business_url": "https://www.providence.org/locations/urgent-care/ak/expresscare-tikahtnu?Is=location&y_source=1_MTQ5MzE2OTYtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=569450515744697362&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "providence-expresscare---tikahtnu-urgent-care",
      "poi_latitude": "61.22750299999999",
      "poi_longitude": "-149.742738",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 888-227-3312",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-2f19-7651-bc3b-5b3ed24736dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-2f19-7651-bc3b-5b3ed24736dc",
        "storage_key": "property/6767906449167177/019d021d-2f19-7651-bc3b-5b3ed24736dc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOZnNOw-VyFYREiwgHDoY5wc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_80845e44-6a5c-42fa-9086-963f310463cb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Credena Health Pharmacy Anchorage",
      "poi_type": "Health and Wellness",
      "poi_address": "3300 Providence Dr #101, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-b19c-76f2-bee3-f0d668cf7dff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412d-b19c-76f2-bee3-f0d668cf7dff",
        "storage_key": "property/6767906449167177/01a1412d-b19c-76f2-bee3-f0d668cf7dff.webp",
        "width": 1280,
        "height": 875
      },
      "poi_business_url": "https://www.cornerdrugstore.com/?corpID=308200&pharmID=1995",
      "poi_directions_map_url": "https://maps.google.com/?cid=1692621507250340689&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "credena-health-pharmacy-anchorage",
      "poi_latitude": "61.18832140000001",
      "poi_longitude": "-149.8177467",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-212-5090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-3c25-7218-a415-5212f9c388ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-3c25-7218-a415-5212f9c388ba",
        "storage_key": "property/6767906449167177/019d021d-3c25-7218-a415-5212f9c388ba.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfcgBSwCXyFYRUcPX_kpmfRc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_3504ceb9-81db-460d-beb8-6e6f1c217a43",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Carrs Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "5600 DeBarr Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021c-cb50-7676-ab69-07d3aaea72dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-cb50-7676-ab69-07d3aaea72dd",
        "storage_key": "property/6767906449167177/019d021c-cb50-7676-ab69-07d3aaea72dd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://local.pharmacy.carrsqc.com/ak/anchorage/5600-debarr-rd.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=16081271465743249979&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carrs-pharmacy",
      "poi_latitude": "61.2081545",
      "poi_longitude": "-149.77705659999998",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 907-339-0960",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-3c25-7218-a415-5212f9c388ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-3c25-7218-a415-5212f9c388ba",
        "storage_key": "property/6767906449167177/019d021d-3c25-7218-a415-5212f9c388ba.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcVWUPI2WyFYRO3JAJDInLN8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_adab2255-8cad-4aea-a800-60a77a9ea2e9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "670 E Northern Lights Blvd, Anchorage, AK 99503, USA",
      "poi_short_description": "Judgment-free gym providing workout equipment plus tanning and massage amenities.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-88c5-74f9-a82f-13ce1b189ccc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021d-88c5-74f9-a82f-13ce1b189ccc",
        "storage_key": "property/6767906449167177/019d021d-88c5-74f9-a82f-13ce1b189ccc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/anchorage-northern-lights-blvd-ak?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=11613855461750134227&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "61.19478189999999",
      "poi_longitude": "-149.87190429999998",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-444-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-2f19-7651-bc3b-5b3ed24736dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-2f19-7651-bc3b-5b3ed24736dc",
        "storage_key": "property/6767906449167177/019d021d-2f19-7651-bc3b-5b3ed24736dc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkSjXk7eXyFYR09VYdgK0LKE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_add27a25-cd81-42c3-a9b7-92404813bbbc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "The Alaska Club Downtown",
      "poi_type": "Health and Wellness",
      "poi_address": "701 W 8th Ave Ste 100, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-b6b4-71cd-b150-2d5251908d8b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412d-b6b4-71cd-b150-2d5251908d8b",
        "storage_key": "property/6767906449167177/01a1412d-b6b4-71cd-b150-2d5251908d8b.webp",
        "width": 537,
        "height": 411
      },
      "poi_business_url": "https://www.thealaskaclub.com/?utm_source=google&utm_medium=organic&utm_campaign=gbp-tacdt-profile",
      "poi_directions_map_url": "https://maps.google.com/?cid=9293149657447986627&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-alaska-club-downtown",
      "poi_latitude": "61.21480699999999",
      "poi_longitude": "-149.89738119999998",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-274-4232",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-3790-70b8-b0d6-4e43d12cbd78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-3790-70b8-b0d6-4e43d12cbd78",
        "storage_key": "property/6767906449167177/019d021d-3790-70b8-b0d6-4e43d12cbd78.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLxe52Ia9yFYRw_W6UGDm94A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_858bcef4-3fa4-4e62-9169-3c444a422a3f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Core Pilates",
      "poi_type": "Health and Wellness",
      "poi_address": "510 W Tudor Rd #9, Anchorage, AK 99503, USA",
      "poi_short_description": "Welcoming Pilates studio offering a wide variety of classes for all fitness levels.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-b3a4-7191-8f35-9756d4ca6ea8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412d-b3a4-7191-8f35-9756d4ca6ea8",
        "storage_key": "property/6767906449167177/01a1412d-b3a4-7191-8f35-9756d4ca6ea8.webp",
        "width": 854,
        "height": 1280
      },
      "poi_business_url": "http://corepilatesak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18346640021676180453&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "core-pilates",
      "poi_latitude": "61.180071",
      "poi_longitude": "-149.892285",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 907-274-2673",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-2f19-7651-bc3b-5b3ed24736dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-2f19-7651-bc3b-5b3ed24736dc",
        "storage_key": "property/6767906449167177/019d021d-2f19-7651-bc3b-5b3ed24736dc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL5xVnJWZyFYR5UP5IeVbnP4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_40c1e80d-7430-4263-8caf-33fd04753be0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Namaste North Yoga and Wellness",
      "poi_type": "Health and Wellness",
      "poi_address": "400 L St Ste 150, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-b6a6-7325-9e62-ad17f79ac104.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412d-b6a6-7325-9e62-ad17f79ac104",
        "storage_key": "property/6767906449167177/01a1412d-b6a6-7325-9e62-ad17f79ac104.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://namastenorthak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9069125572253388481&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "namaste-north-yoga-and-wellness",
      "poi_latitude": "61.2183678",
      "poi_longitude": "-149.9044142",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 907-277-2256",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-2f19-7651-bc3b-5b3ed24736dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-2f19-7651-bc3b-5b3ed24736dc",
        "storage_key": "property/6767906449167177/019d021d-2f19-7651-bc3b-5b3ed24736dc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn2U2vYe9yFYRwQ6TXagB3H0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_fb727162-687a-4c23-a733-0c961525c0c4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Cheney Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2245 Baxter Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "Peaceful city park featuring scenic walking trails and lake fishing.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-bb08-71ad-a535-91d59782056e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412d-bb08-71ad-a535-91d59782056e",
        "storage_key": "property/6767906449167177/01a1412d-bb08-71ad-a535-91d59782056e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1659871588540635741&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cheney-lake-park",
      "poi_latitude": "61.200136",
      "poi_longitude": "-149.7630764",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-37e6-719a-b4b6-7f90e8a3d87a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-37e6-719a-b4b6-7f90e8a3d87a",
        "storage_key": "property/6767906449167177/019d021d-37e6-719a-b4b6-7f90e8a3d87a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJza3J7-qWyFYRXVq6V2oMCRc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_62cb3b4b-947d-402a-af38-022174544cfd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Nunaka Valley Park South",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6111 Craig Dr, Anchorage, AK 99504, USA",
      "poi_short_description": "Hillside place to walk dogs and sled in winter, plus baseball fields and a playground.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-b9bf-707c-812a-47d6252ef3c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412d-b9bf-707c-812a-47d6252ef3c9",
        "storage_key": "property/6767906449167177/01a1412d-b9bf-707c-812a-47d6252ef3c9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4569113285713326970&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nunaka-valley-park-south",
      "poi_latitude": "61.2040321",
      "poi_longitude": "-149.76721999999998",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-37e6-719a-b4b6-7f90e8a3d87a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-37e6-719a-b4b6-7f90e8a3d87a",
        "storage_key": "property/6767906449167177/019d021d-37e6-719a-b4b6-7f90e8a3d87a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh1Nx0uyWyFYRevN1PVPAaD8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_545cc7e9-05f2-40b7-b143-5e8f1f013fdd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Russian Jack Springs Park North",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "801 Pine St, Anchorage, AK 99508, USA",
      "poi_short_description": "4-season outdoor activity area with a golf course, tennis courts, lighted trails & soccer fields.",
      "poi_long_description": "4-season outdoor activity area with a golf course, tennis courts, lighted trails & soccer fields.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-b91a-7497-82fc-16b87ad2f1ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412d-b91a-7497-82fc-16b87ad2f1ac",
        "storage_key": "property/6767906449167177/01a1412d-b91a-7497-82fc-16b87ad2f1ac.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12943037161126535362&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "russian-jack-springs-park-north",
      "poi_latitude": "61.213344199999995",
      "poi_longitude": "-149.786862",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-37e6-719a-b4b6-7f90e8a3d87a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-37e6-719a-b4b6-7f90e8a3d87a",
        "storage_key": "property/6767906449167177/019d021d-37e6-719a-b4b6-7f90e8a3d87a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-XounPOWyFYRwqCgD7nnnrM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_e02b328b-cf77-48d1-8cb5-68a8acac81d9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "University Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4050 University Lake Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "Scenic lakeside dog park with walking trails and swimming areas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-bce7-74bf-8433-a6bfba652930.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412d-bce7-74bf-8433-a6bfba652930",
        "storage_key": "property/6767906449167177/01a1412d-bce7-74bf-8433-a6bfba652930.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14589859302453206728&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-lake-park",
      "poi_latitude": "61.1848311",
      "poi_longitude": "-149.8077434",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-37e6-719a-b4b6-7f90e8a3d87a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-37e6-719a-b4b6-7f90e8a3d87a",
        "storage_key": "property/6767906449167177/019d021d-37e6-719a-b4b6-7f90e8a3d87a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJu_rUugKXyFYRyN6mNbyXeco",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "custom_72f16b6c-f462-4bb0-aacc-1fc75c040ddd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Delaney Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "W 9th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Big park with sports fields, tennis courts & horseshoe pits, plus an ice-hockey rink & skating area.",
      "poi_long_description": "Big park with sports fields, tennis courts & horseshoe pits, plus an ice-hockey rink & skating area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412b-7f9c-71ec-a85c-15747c263e7d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412b-7f9c-71ec-a85c-15747c263e7d",
        "storage_key": "property/6767906449167177/01a1412b-7f9c-71ec-a85c-15747c263e7d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://muni.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1290405951593808698&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "delaney-park",
      "poi_latitude": "61.213055",
      "poi_longitude": "-149.89622699999998",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-37e6-719a-b4b6-7f90e8a3d87a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-37e6-719a-b4b6-7f90e8a3d87a",
        "storage_key": "property/6767906449167177/019d021d-37e6-719a-b4b6-7f90e8a3d87a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5QWeniqWyFYROoPMSGBx6BE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6b8c5e27-57bf-47d0-86f8-f71aeb12c38f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Town Square Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "544 W 5th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Small park featuring flowers & concerts in the summer, plus ice sculptures & a rink in the winter.",
      "poi_long_description": "Small park featuring flowers & concerts in the summer, plus ice sculptures & a rink in the winter.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-be0e-73ac-ae63-e8c684f91b4b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412d-be0e-73ac-ae63-e8c684f91b4b",
        "storage_key": "property/6767906449167177/01a1412d-be0e-73ac-ae63-e8c684f91b4b.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12145788217067135527&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "town-square-park",
      "poi_latitude": "61.217028",
      "poi_longitude": "-149.892606",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-37e6-719a-b4b6-7f90e8a3d87a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-37e6-719a-b4b6-7f90e8a3d87a",
        "storage_key": "property/6767906449167177/019d021d-37e6-719a-b4b6-7f90e8a3d87a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJIytn_SmWyFYRJ2JpQwiCjqg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_67414d62-8d6a-498b-a7d5-166fadf69295",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Peratrovich Park/Old City Hall Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "500 W 4th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-c576-74e8-8f8f-34ca45e8f4dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412d-c576-74e8-8f8f-34ca45e8f4dd",
        "storage_key": "property/6767906449167177/01a1412d-c576-74e8-8f8f-34ca45e8f4dd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2399651022926501563&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "peratrovich-parkold-city-hall-park",
      "poi_latitude": "61.2182857",
      "poi_longitude": "-149.8918087",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-343-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-37e6-719a-b4b6-7f90e8a3d87a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-37e6-719a-b4b6-7f90e8a3d87a",
        "storage_key": "property/6767906449167177/019d021d-37e6-719a-b4b6-7f90e8a3d87a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJg9WbZIe9yFYRu9ZvNuRFTSE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_6dc9c4df-c90b-46f6-8169-6a3de7a1dff5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Coastal Trail - 2nd and H St",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "H St, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-c3fc-713c-a6bb-ed4a5f382e3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412d-c3fc-713c-a6bb-ed4a5f382e3a",
        "storage_key": "property/6767906449167177/01a1412d-c3fc-713c-a6bb-ed4a5f382e3a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11160247703349159867&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "coastal-trail---2nd-and-h-st",
      "poi_latitude": "61.220540699999994",
      "poi_longitude": "-149.8975039",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-e23c-760a-9ca4-fe93a40ca6da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1412d-e23c-760a-9ca4-fe93a40ca6da",
        "storage_key": "property/6767906449167177/01a1412d-e23c-760a-9ca4-fe93a40ca6da.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJhS349Ia9yFYRu-d-Gygq4Zo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_1a91480a-3809-4a34-82bf-eb5e803b3633",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Downtown Transit Center Pass",
      "poi_type": "Transportation & Transit",
      "poi_address": "700 W 6th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-c653-75ff-937e-291aa26346cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412d-c653-75ff-937e-291aa26346cd",
        "storage_key": "property/6767906449167177/01a1412d-c653-75ff-937e-291aa26346cd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.peoplemover.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11500851897172059445&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "downtown-transit-center-pass",
      "poi_latitude": "61.21588799999999",
      "poi_longitude": "-149.8964133",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-343-6543",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-2f19-7651-bc3b-5b3ed24736dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-2f19-7651-bc3b-5b3ed24736dc",
        "storage_key": "property/6767906449167177/019d021d-2f19-7651-bc3b-5b3ed24736dc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq2bquYC9yFYRNWVRyd07m58",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_78202403-19e1-473b-9263-0e73c372a59c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Anchorage Depot",
      "poi_type": "Transportation & Transit",
      "poi_address": "411 W 1st Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "Classic train station built in the 1940s featuring model train displays, a gift shop & scenic rides.",
      "poi_long_description": "Classic train station built in the 1940s featuring model train displays, a gift shop & scenic rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412b-874a-7608-b2a0-ca3c23bdecb0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412b-874a-7608-b2a0-ca3c23bdecb0",
        "storage_key": "property/6767906449167177/01a1412b-874a-7608-b2a0-ca3c23bdecb0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.alaskarailroad.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3741649916070368533&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-depot",
      "poi_latitude": "61.2216964",
      "poi_longitude": "-149.8901898",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 800-544-0552",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-3c1a-73dc-beb8-ad8d09b112c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-3c1a-73dc-beb8-ad8d09b112c1",
        "storage_key": "property/6767906449167177/019d021d-3c1a-73dc-beb8-ad8d09b112c1.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJfd_0CYi9yFYRFZU-ScYC7TM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_276fd7a6-7f5a-4b19-a335-fa5dcde073df",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Ted Stevens Anchorage International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "5000 W International Airport Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "Built in 1951, flights from this airport can reach 90% of the industrialized world within 9.5 hours.",
      "poi_long_description": "Built in 1951, flights from this airport can reach 90% of the industrialized world within 9.5 hours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-ca51-7761-b36e-fe7da7b88021.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412d-ca51-7761-b36e-fe7da7b88021",
        "storage_key": "property/6767906449167177/01a1412d-ca51-7761-b36e-fe7da7b88021.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://dot.alaska.gov/anc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10860248208626249647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ted-stevens-anchorage-international-airport",
      "poi_latitude": "61.1769173",
      "poi_longitude": "-149.9905923",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 907-266-2526",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-3ffb-74b0-a0c7-ec599a9538ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-3ffb-74b0-a0c7-ec599a9538ee",
        "storage_key": "property/6767906449167177/019d021d-3ffb-74b0-a0c7-ec599a9538ee.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJERqXa7WiyFYRr2-9pzRat5Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_9bcf3e12-75c7-4b71-9230-28c1371604a9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Bill Sheffield Alaska Railroad Depot",
      "poi_type": "Transportation & Transit",
      "poi_address": "4980 W International Airport Rd, Anchorage, AK 99502, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-c78a-7037-b27b-9f6e6101deb9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412d-c78a-7037-b27b-9f6e6101deb9",
        "storage_key": "property/6767906449167177/01a1412d-c78a-7037-b27b-9f6e6101deb9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.alaskarailroad.com/real-estate/depot-rentals",
      "poi_directions_map_url": "https://maps.google.com/?cid=17805455315424171249&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bill-sheffield-alaska-railroad-depot",
      "poi_latitude": "61.1745567",
      "poi_longitude": "-149.9804143",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 907-265-2466",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412b-994d-705a-8606-b3aaaaddf22e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1412b-994d-705a-8606-b3aaaaddf22e",
        "storage_key": "property/6767906449167177/01a1412b-994d-705a-8606-b3aaaaddf22e.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-yjDfmujyFYR8dTyo0WvGfc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_depot"
    },
    {
      "id": "custom_18cb8907-a4c8-41ce-935e-ade6cbe99e2a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Lake Hood Seaplane Base, Anchorage, Alaska, USA | StreamTime LIVE",
      "poi_type": "Entertainment",
      "poi_address": "4512 Enstrom Cir, Anchorage, AK 99502, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-ce8d-733e-9182-41362abe5e90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412d-ce8d-733e-9182-41362abe5e90",
        "storage_key": "property/6767906449167177/01a1412d-ce8d-733e-9182-41362abe5e90.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8596015807092976490&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-hood-seaplane-base-anchorage-alaska-usa--streamtime-live",
      "poi_latitude": "61.179624999999994",
      "poi_longitude": "-149.9719036",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 14 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-e23b-7779-9652-3db867dcf636.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1412d-e23b-7779-9652-3db867dcf636",
        "storage_key": "property/6767906449167177/01a1412d-e23b-7779-9652-3db867dcf636.webp",
        "width": 192,
        "height": 139
      },
      "poi_google_place_id": "ChIJx7qxxx69yFYRamtrOdUuS3c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "custom_474ae4b7-c135-441d-a312-3244a6d144c4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Merrill Field Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "800 Merrill Field Dr, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-a28a-74cd-b772-b69796199694.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021d-a28a-74cd-b772-b69796199694",
        "storage_key": "property/6767906449167177/019d021d-a28a-74cd-b772-b69796199694.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.muni.org/Departments/merrill_field/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=3690256857556359428&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "merrill-field-airport",
      "poi_latitude": "61.215917",
      "poi_longitude": "-149.8419312",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-343-6303",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-3ffb-74b0-a0c7-ec599a9538ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-3ffb-74b0-a0c7-ec599a9538ee",
        "storage_key": "property/6767906449167177/019d021d-3ffb-74b0-a0c7-ec599a9538ee.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJF1chpUeWyFYRBJmYZA9tNjM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_fce7984a-ac00-4856-94cd-53335e15a74b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Dimond Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Anchorage, AK 99515, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-d001-776a-9771-81dd12e0bd3b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412d-d001-776a-9771-81dd12e0bd3b",
        "storage_key": "property/6767906449167177/01a1412d-d001-776a-9771-81dd12e0bd3b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17211653549311854446&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dimond-transit-center",
      "poi_latitude": "61.142764",
      "poi_longitude": "-149.871953",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-e23d-738c-a0b0-26212dbb3850.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1412d-e23d-738c-a0b0-26212dbb3850",
        "storage_key": "property/6767906449167177/01a1412d-e23d-738c-a0b0-26212dbb3850.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJyVAwvdGZyFYRbgfTO7YT3O4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_72f44819-3b4d-4fa8-a3b2-475edc26b2cf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Tikahtnu Commons",
      "poi_type": "Shopping & Retail",
      "poi_address": "1142 N Muldoon Rd, Anchorage, AK 99504, USA",
      "poi_short_description": "Expansive shopping center featuring a variety of retail stores, restaurants, and a movie theater.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-d280-7131-9ca8-082a5f997ce5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412d-d280-7131-9ca8-082a5f997ce5",
        "storage_key": "property/6767906449167177/01a1412d-d280-7131-9ca8-082a5f997ce5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://tikahtnucommons.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4413898816297472885&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tikahtnu-commons",
      "poi_latitude": "61.2285985",
      "poi_longitude": "-149.7419444",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-3396-733f-bb18-2cd95942572d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-3396-733f-bb18-2cd95942572d",
        "storage_key": "property/6767906449167177/019d021d-3396-733f-bb18-2cd95942572d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8dy9OSaUyFYRdZPta5ZRQT0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_e72b988c-2cfd-497a-9444-051350c809af",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Northway Mall",
      "poi_type": "Transportation & Transit",
      "poi_address": "Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-d157-772d-ad93-717dd4f07d6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412d-d157-772d-ad93-717dd4f07d6a",
        "storage_key": "property/6767906449167177/01a1412d-d157-772d-ad93-717dd4f07d6a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12489496896778437116&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northway-mall",
      "poi_latitude": "61.21573000000001",
      "poi_longitude": "-149.821383",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-e23d-738c-a0b0-26212dbb3850.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1412d-e23d-738c-a0b0-26212dbb3850",
        "storage_key": "property/6767906449167177/01a1412d-e23d-738c-a0b0-26212dbb3850.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJBXxq-EKWyFYR_IHSY0GbU60",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_d0423bd2-b373-49ab-b90d-c412486f9a6e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Port Of Alaska",
      "poi_type": "Transportation & Transit",
      "poi_address": "2000 Anchorage Port Rd, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-d19e-70f8-983f-ce9890004b10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412d-d19e-70f8-983f-ce9890004b10",
        "storage_key": "property/6767906449167177/01a1412d-d19e-70f8-983f-ce9890004b10.webp",
        "width": 952,
        "height": 984
      },
      "poi_business_url": "http://www.portofalaska.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1615135989646056101&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "port-of-alaska",
      "poi_latitude": "61.2393502",
      "poi_longitude": "-149.8880141",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 907-343-6200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-e23d-738c-a0b0-26212dbb3850.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a1412d-e23d-738c-a0b0-26212dbb3850",
        "storage_key": "property/6767906449167177/01a1412d-e23d-738c-a0b0-26212dbb3850.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJORWui_K9yFYRpVrNDqAdahY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "custom_9e30f00a-e64d-4a3e-bcd4-f704d8aab576",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Providence Alaska Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "3200 Providence Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412b-7c57-7484-af93-98e50fb9dfe9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412b-7c57-7484-af93-98e50fb9dfe9",
        "storage_key": "property/6767906449167177/01a1412b-7c57-7484-af93-98e50fb9dfe9.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.providence.org/locations/ak/alaska-medical-center?ls=location&y_source=1_OTU3NTY4Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=1990875543032169585&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "providence-alaska-medical-center",
      "poi_latitude": "61.1866256",
      "poi_longitude": "-149.82213539999998",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-562-2211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-3b98-76ba-9930-52bab3b868cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-3b98-76ba-9930-52bab3b868cf",
        "storage_key": "property/6767906449167177/019d021d-3b98-76ba-9930-52bab3b868cf.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ__razgCXyFYRcQRyHsICoRs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_5c214b9c-ec89-42e5-a562-9b5b817ae367",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Alaska Native Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "4315 Diplomacy Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021c-f54c-76c9-890d-713f4cbf32a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-f54c-76c9-890d-713f4cbf32a0",
        "storage_key": "property/6767906449167177/019d021c-f54c-76c9-890d-713f4cbf32a0.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "http://anmc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12633987291157363904&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-native-medical-center",
      "poi_latitude": "61.182452",
      "poi_longitude": "-149.80024269999998",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-563-2662",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-3b98-76ba-9930-52bab3b868cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-3b98-76ba-9930-52bab3b868cf",
        "storage_key": "property/6767906449167177/019d021d-3b98-76ba-9930-52bab3b868cf.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJV_bUZRyXyFYRwPw76oDwVK8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_57b17ae4-ba19-4697-ada1-67b065363306",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Alaska Native Tribal Health Consortium",
      "poi_type": "Health and Wellness",
      "poi_address": "4000 Ambassador Dr, Anchorage, AK 99508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-d5a3-742a-8e15-755e7194b3b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412d-d5a3-742a-8e15-755e7194b3b2",
        "storage_key": "property/6767906449167177/01a1412d-d5a3-742a-8e15-755e7194b3b2.webp",
        "width": 1280,
        "height": 301
      },
      "poi_business_url": "http://www.anthc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1002423738872135572&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-native-tribal-health-consortium",
      "poi_latitude": "61.184003999999995",
      "poi_longitude": "-149.7994651",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-729-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-3b98-76ba-9930-52bab3b868cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-3b98-76ba-9930-52bab3b868cf",
        "storage_key": "property/6767906449167177/019d021d-3b98-76ba-9930-52bab3b868cf.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ7c0qhyXyFYRlH_kVRRT6Q0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "custom_fe4efd26-ffee-4d8d-a404-ac71da9e9c52",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Anchorage City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "632 W 6th Ave, Anchorage, AK 99501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412b-8811-7358-be7e-7c4a07bc4438.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412b-8811-7358-be7e-7c4a07bc4438",
        "storage_key": "property/6767906449167177/01a1412b-8811-7358-be7e-7c4a07bc4438.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.muni.org/pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=1064156177697528647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-city-hall",
      "poi_latitude": "61.216329900000005",
      "poi_longitude": "-149.8948221",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-343-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-3bac-702d-a4ba-6b2ad62498df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-3bac-702d-a4ba-6b2ad62498df",
        "storage_key": "property/6767906449167177/019d021d-3bac-702d-a4ba-6b2ad62498df.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQDkroC9yFYRR9syzWekxA4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_eb6535b1-4049-4f38-8c50-35f83b268142",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "Anchorage School District",
      "poi_type": "Education",
      "poi_address": "5530 E Northern Lights Blvd, Anchorage, AK 99504, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/01a1412d-d84c-734c-abfd-94831a667227.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a1412d-d84c-734c-abfd-94831a667227",
        "storage_key": "property/6767906449167177/01a1412d-d84c-734c-abfd-94831a667227.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.asdk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11253021771947721235&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anchorage-school-district",
      "poi_latitude": "61.193963100000005",
      "poi_longitude": "-149.7754994",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-742-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-3790-70b8-b0d6-4e43d12cbd78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-3790-70b8-b0d6-4e43d12cbd78",
        "storage_key": "property/6767906449167177/019d021d-3790-70b8-b0d6-4e43d12cbd78.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJc3ueb-mWyFYRE0KuNq7DKpw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d384032c-448d-4aa7-8a49-39d81e4c80f6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "custom",
      "poi_name": "JBER Public Affairs",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10480 Sijan Ave, Anchorage, AK 99506, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.jber.jb.mil/Services-Resources/Public-Affairs/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18373584563523412467&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jber-public-affairs",
      "poi_latitude": "61.2471852",
      "poi_longitude": "-149.80933059999998",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-552-8151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167177/019d021d-3bac-702d-a4ba-6b2ad62498df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-3bac-702d-a4ba-6b2ad62498df",
        "storage_key": "property/6767906449167177/019d021d-3bac-702d-a4ba-6b2ad62498df.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpVGywKKVyFYR8-FpJ9AV_P4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    }
  ],
  "office_hours": [
    {
      "id": "ec_014f6e32acf3a052c2180f4e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_2def9fc1e65a5845f1d38409",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_78fe960feb45d48c39ff6dc9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_750996485abc94d1778151f9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_5d4095b239692492dfc79500",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [],
  "virtual_tours": [],
  "faqs": [],
  "fees": [],
  "pet_policies": [
    {
      "id": "ec_18ad7c2e354b8696a9fd7713",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "yardi",
      "external_id": "2470796",
      "pet_type": "cats",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 300,
      "monthly_rent": 40,
      "description": "Up to 2 pets per home are welcome.",
      "restrictions": "false"
    },
    {
      "id": "ec_bb65b14bebc750a2bd6ca8c8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "yardi",
      "external_id": "2470795",
      "pet_type": "dogs",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 300,
      "monthly_rent": 40,
      "description": "Up to 2 pets per home are welcome.",
      "restrictions": "Breed restrictions apply"
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "01a19d29-dab1-70b8-91d6-e3300965eb08",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Brighton Woods Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "generator",
      "page_item_url": "in-home-washer-dryer-apartments-brighton",
      "search_query": "apartments with in-home washer dryer anchorage",
      "category": "Amenity",
      "h1_title": "Apartments with In-Home Washer Dryer",
      "h2_subtitle": "Discover Brighton Woods in Northeast Anchorage, where select homes offer convenient in-home washer and dryer facilities for residents.",
      "page_copy": "Enjoy the convenience of in-home washer and dryer units in select homes at Brighton Woods, located in the charming Northeast Anchorage neighborhood. These apartments are perfect for those seeking comfort and practicality in their living spaces. At Brighton Woods, you'll appreciate the thoughtful amenities such as walk-in closets and smoke-free living, enhancing your lifestyle.\n\nNortheast Anchorage offers a vibrant community atmosphere, and Brighton Woods provides easy access to dining and entertainment. Imagine coming home after a long day and having the luxury of your own laundry facilities, right in your apartment. Experience the ease of apartment living with personalized amenities in a beautiful Anchorage Municipality setting.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Home Washer Dryer in Anchorage",
      "seo_description": "Explore Brighton Woods in Anchorage, offering select apartments with in-home washer and dryer. Enjoy practical amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "generator",
      "page_item_url": "dishwasher-equipped-apartments-brighton",
      "search_query": "dishwasher equipped apartments northeast anchorage",
      "category": "Amenity",
      "h1_title": "Dishwasher Equipped Apartments",
      "h2_subtitle": "Experience the ease of living at Brighton Woods, where select homes in Northeast Anchorage come with the convenience of a dishwasher.",
      "page_copy": "Brighton Woods offers dishwasher equipped apartments in the heart of Northeast Anchorage, making daily chores simpler for residents. Imagine the convenience of a modern kitchen where meal clean-up is a breeze, allowing you more time to relax and enjoy the community's amenities.\n\nLocated in the vibrant Northeast Anchorage neighborhood, Brighton Woods features smoke-free homes and thoughtful elements like walk-in closets and dining rooms. With additional features such as a fireplace in select units, your apartment becomes a cozy retreat. Enjoy the freshness of smoke-free living while having the added convenience of a dishwasher in your home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dishwasher Equipped Apartments in Anchorage",
      "seo_description": "Discover Brighton Woods in Northeast Anchorage, where select homes include dishwashers. Enjoy easy living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "generator",
      "page_item_url": "smoke-free-apartments-anchorage-brighton",
      "search_query": "smoke free apartments in anchorage municipality",
      "category": "Amenity",
      "h1_title": "Smoke Free Apartments in Anchorage",
      "h2_subtitle": "Brighton Woods offers a healthier living environment with smoke free apartments in Anchorage Municipality's Northeast Anchorage area.",
      "page_copy": "At Brighton Woods, enjoy the benefits of smoke free apartments situated in the beautiful Anchorage Municipality. These homes provide a fresh and clean atmosphere, ideal for individuals who prioritize their health and well-being. With amenities tailored for comfort, such as in-home washer and dryer units in select homes, you'll find convenience and peace of mind.\n\nLocated in Northeast Anchorage, Brighton Woods is more than just a place to live; it's a community that values a clean and smoke-free environment. Our apartments feature various comforts like walk-in closets and fireplaces in select units, ensuring a cozy living experience. Embrace a lifestyle focused on health in this vibrant community.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smoke Free Apartments in Anchorage",
      "seo_description": "Explore Brighton Woods' smoke free apartments in Anchorage Municipality. Live in a healthy, vibrant community with convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "generator",
      "page_item_url": "walk-in-closets-apartment-99504-brighton",
      "search_query": "walk-in closets apartment in 99504",
      "category": "Amenity",
      "h1_title": "Walk-In Closets Apartment in 99504",
      "h2_subtitle": "Find spacious living at Brighton Woods featuring apartments with walk-in closets, located in the heart of the 99504 ZIP code.",
      "page_copy": "Brighton Woods, nestled in the vibrant 99504 area, offers the luxury of walk-in closets in every apartment, providing ample storage and an organized living space. These thoughtfully designed apartments cater to your storage needs while ensuring your home remains clutter-free and elegant.\n\nLocated in the picturesque Northeast Anchorage, Brighton Woods boasts not only walk-in closets but also a range of amenities such as fireplaces in select homes and smoke-free living throughout the community. Enjoy the blend of comfort and functionality, with additional perks like in-home washer and dryer units making daily tasks convenient. Experience the perfect Anchorage Municipality lifestyle here.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Walk-In Closets Apartment in 99504 Anchorage",
      "seo_description": "Discover Brighton Woods in Anchorage's 99504, featuring apartments with spacious walk-in closets. Enjoy comfort and convenience in a smoke-free community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "generator",
      "page_item_url": "online-payments-apartment-ne-anchorage-brighton",
      "search_query": "online payments apartment in northeast anchorage",
      "category": "Amenity",
      "h1_title": "Online Payments Apartment in NE Anchorage",
      "h2_subtitle": "Experience modern convenience with online payments at Brighton Woods, offering apartments in Northeast Anchorage designed for easy living.",
      "page_copy": "Brighton Woods in Northeast Anchorage provides residents with the ease of online payments, making rent management as seamless as possible. This service reflects our commitment to modern, efficient living, ensuring you have more time to enjoy what truly matters.\n\nOur apartment community, located in the serene part of Anchorage Municipality, also offers smoke-free living and features such as walk-in closets and fireplaces in select units. Brighton Woods combines convenience with comfort, allowing you to manage payments from the comfort of your home while enjoying amenities designed to enhance your lifestyle.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Online Payments Apartment in NE Anchorage",
      "seo_description": "Discover Brighton Woods in Northeast Anchorage, offering easy online payments and comfortable living in a smoke-free community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-northeast-anchorage-brighton",
      "search_query": "one bedroom apartments northeast anchorage",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Northeast Anchorage",
      "h2_subtitle": "Explore beautiful one bedroom apartments at Brighton Woods, located in the heart of Northeast Anchorage.",
      "page_copy": "Brighton Woods offers charming one bedroom apartments located in the desirable Northeast Anchorage area. These apartments combine style and functionality, featuring modern amenities designed to enhance your living experience. From spacious walk-in closets that provide ample storage to the cozy ambiance of fireplaces in select units, Brighton Woods caters to a variety of lifestyle needs.\n\nSituated within the Anchorage Municipality, our community ensures a comfortable living environment in a smoke-free setting. Residents can also enjoy convenient amenities such as dining rooms and walk-up access, making daily life simple and enjoyable. Discover the beauty of Northeast Anchorage with Brighton Woods as your home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in NE Anchorage",
      "seo_description": "Discover one bedroom apartments at Brighton Woods in Northeast Anchorage, offering modern amenities in a smoke-free community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "generator",
      "page_item_url": "two-bedroom-rentals-anchorage-ak-brighton",
      "search_query": "two bedroom rentals anchorage ak",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Rentals in Anchorage, AK",
      "h2_subtitle": "Find perfect two bedroom rentals at Brighton Woods, located in serene Anchorage, AK, offering spacious and comfortable living spaces.",
      "page_copy": "Brighton Woods offers exceptional two bedroom rentals in the heart of Anchorage, AK, where you'll find spacious layouts and modern amenities designed for comfortable living. Each unit features walk-in closets, perfect for all your storage needs, and select homes have the added charm of a cozy fireplace, creating an inviting atmosphere.\n\nLocated in the vibrant community of Northeast Anchorage, our rentals provide a smoke-free environment with convenient access to dining rooms and walk-up entry. Experience the best of Anchorage living with a range of features intended to elevate your lifestyle at Brighton Woods.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Rentals in Anchorage, AK",
      "seo_description": "Explore two bedroom rentals at Brighton Woods in Anchorage, AK, combining comfort and convenience in a desirable, smoke-free community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "generator",
      "page_item_url": "apartments-near-university-of-alaska-anchorage",
      "search_query": "apartments near University of Alaska Anchorage",
      "category": "School",
      "h1_title": "Apartments Near University of Alaska Anchorage",
      "h2_subtitle": "Discover Brighton Woods, offering comfortable apartments conveniently located near the University of Alaska Anchorage.",
      "page_copy": "Located just a short drive from the University of Alaska Anchorage, Brighton Woods provides the perfect home base for students and faculty alike. Our apartments offer a blend of comfort and convenience, featuring amenities like walk-in closets and dining rooms to enhance everyday life.\n\nIn the picturesque area of Northeast Anchorage, Brighton Woods offers a desirable smoke-free environment with select homes equipped with fireplaces for an added touch of warmth. Whether you're studying or teaching at the university, Brighton Woods offers an ideal location with all the comforts of home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University of Alaska Anchorage",
      "seo_description": "Conveniently located near the University of Alaska Anchorage, Brighton Woods offers comfortable living in Northeast Anchorage.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "generator",
      "page_item_url": "apartments-near-alaska-native-medical-center-ne",
      "search_query": "apartments near Alaska Native Medical Center Northeast Anchorage",
      "category": "Hospital",
      "h1_title": "Apartments Near Alaska Native Medical Center",
      "h2_subtitle": "Brighton Woods offers ideal apartments situated near Alaska Native Medical Center in Northeast Anchorage with modern comforts and amenities.",
      "page_copy": "For those seeking proximity to the Alaska Native Medical Center in Northeast Anchorage, Brighton Woods provides an ideal residential option. Our apartments, located in this vibrant part of Anchorage, offer a harmonious blend of convenience and comfort, with amenities designed for modern living.\n\nResidents of Brighton Woods appreciate the community's smoke-free environment, spacious walk-in closets, and the charm of fireplaces in select homes. Additionally, the walk-up design provides ease of access. Whether you are a healthcare professional or seeking nearby medical services, our location near the Alaska Native Medical Center makes Brighton Woods a perfect fit.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Alaska Native Medical Center",
      "seo_description": "Brighton Woods in Northeast Anchorage offers ideal apartments near the Alaska Native Medical Center, featuring modern comforts and conveniences.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "generator",
      "page_item_url": "apartments-close-to-providence-alaska-medical-center",
      "search_query": "apartments close to Providence Alaska Medical Center Anchorage AK",
      "category": "Hospital",
      "h1_title": "Apartments Close to Providence Alaska Medical Center",
      "h2_subtitle": "Discover Brighton Woods, ideally located just minutes from Providence Alaska Medical Center in Anchorage, AK, offering a comfortable living experience.",
      "page_copy": "Brighton Woods, nestled in the heart of Anchorage, AK, offers convenient living just moments away from Providence Alaska Medical Center. Ideal for healthcare professionals and those seeking proximity to medical services, our community provides a peaceful yet accessible retreat with thoughtful amenities.\n\nOur apartments feature spacious walk-in closets, smoke-free living, and select homes with fireplaces to enhance your living experience. With easy access to your workplace or healthcare services, Brighton Woods combines convenience with the comforts of home in Northeast Anchorage, making it an excellent choice for those looking to be near Providence Alaska Medical Center.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Close to Providence Alaska Medical Center",
      "seo_description": "Experience convenient living at Brighton Woods, near Providence Alaska Medical Center, offering comfortable apartments in Anchorage, AK.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "generator",
      "page_item_url": "apartments-near-alaska-botanical-garden-ne-anchorage",
      "search_query": "apartments near alaska botanical garden northeast anchorage",
      "category": "Park",
      "h1_title": "Apartments Near Alaska Botanical Garden",
      "h2_subtitle": "Explore Brighton Woods, offering charming apartments near Alaska Botanical Garden in Northeast Anchorage with serene living spaces and modern amenities.",
      "page_copy": "Situated nearby the beautiful Alaska Botanical Garden in Northeast Anchorage, Brighton Woods presents an ideal living situation for nature lovers and outdoor enthusiasts. Our community offers not only proximity to this lush landscape but also a harmonious blend of convenience and homey comforts.\n\nAt Brighton Woods, residents enjoy spacious walk-in closets and a welcoming, smoke-free environment. Select homes come with cozy fireplaces, enhancing the warmth of your living space. Nestled within easy reach of the garden, Brighton Woods provides a perfect home base for enjoying the natural beauty of Northeast Anchorage while still having all modern amenities at your fingertips.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Alaska Botanical Garden",
      "seo_description": "Brighton Woods offers apartments near the Alaska Botanical Garden, providing a serene living experience with modern amenities in Northeast Anchorage.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167177",
      "source": "generator",
      "page_item_url": "brighton-woods-apartments-close-to-delaney-park",
      "search_query": "brighton woods apartments close to delaney park anchorage",
      "category": "Park",
      "h1_title": "Brighton Woods Apartments Near Delaney Park",
      "h2_subtitle": "Discover Brighton Woods, conveniently located next to Delaney Park in Anchorage, offering a perfect blend of serene living and urban convenience.",
      "page_copy": "Brighton Woods is the ideal community for those desiring a blend of city life and green spaces, strategically located close to Delaney Park in Anchorage. The park, a local favorite for recreation and relaxation, is just a short distance away, offering an inviting escape from daily routines.\n\nResidents of Brighton Woods appreciate the peaceful setting paired with modern amenities. With walk-in closets, a smoke-free environment, and select units featuring fireplaces, our apartments deliver both style and comfort. Experience the ease of access to downtown Anchorage while enjoying the tranquility and leisure options presented by nearby Delaney Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Brighton Woods Apts Near Delaney Park",
      "seo_description": "Live at Brighton Woods, near Delaney Park in Anchorage, combining urban convenience with serene living and welcoming amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11309408528"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=9073085055"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-WFQH2CVS"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 8"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Comfy"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/ad6cb684-90d6-4593-8736-554557f2afc3/app.js?property=ad6cb684-90d6-4593-8736-554557f2afc3&propertyName=Brighton+Woods&channelUuid=c2490004-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "47678981036"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InBMSmdlNnJRcEhpWW9GUU1hS2traVE9PSIsInZhbHVlIjoiRnhzaTR5VTR4TzRDYkRicEp3Y2F2dz09IiwibWFjIjoiYTZmODFkMWM2MDQyN2ViYTIxNTMxY2Q0NzBmOGE4MDlhYjlhOWI2MGQ4ZTkxMGNhZDU1N2Q0NmIxYTg3NTViNiJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "11309408528",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=9073085055",
  "custom_google_gtm_id": "GTM-WFQH2CVS",
  "custom_rollout_phase": "Phase 8",
  "custom_vibesites_theme": "Comfy",
  "custom_ads_subscription": "none",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/ad6cb684-90d6-4593-8736-554557f2afc3/app.js?property=ad6cb684-90d6-4593-8736-554557f2afc3&propertyName=Brighton+Woods&channelUuid=c2490004-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "47678981036",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6InBMSmdlNnJRcEhpWW9GUU1hS2traVE9PSIsInZhbHVlIjoiRnhzaTR5VTR4TzRDYkRicEp3Y2F2dz09IiwibWFjIjoiYTZmODFkMWM2MDQyN2ViYTIxNTMxY2Q0NzBmOGE4MDlhYjlhOWI2MGQ4ZTkxMGNhZDU1N2Q0NmIxYTg3NTViNiJ9",
  "custom_audioeye_site_id": "e00ba2f5-15ee-48b8-b71b-ef371fea55ea",
  "custom_audioeye_site_hash": "857840adee3689499bae02567f29dd19"
};

export const generatedAt = '2026-11-04T00:23:01.900Z';
